import React, {
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import Preloader from "../../PreloaderGrids/Preloader";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {
    ThemeProvider,
    createTheme,
} from "@mui/material/styles";

import {
    DataGrid,
    GridFooterContainer,
    GridPagination,
    ptBR,
} from "@mui/x-data-grid";

import Select from "react-select";

import DatePicker, {
    registerLocale,
    setDefaultLocale,
} from "react-datepicker";

import {
    ptBR as ptBRDateFns,
} from "date-fns/locale/pt-BR";

import {
    format,
} from "date-fns";

import Swal from "sweetalert2";

import {
    TbReportAnalytics,
    TbMap2,
    TbGps,
} from "react-icons/tb";

import {
    RiFileExcel2Line,
} from "react-icons/ri";

import {
    FaRegFilePdf,
} from "react-icons/fa";

import {
    MdGpsFixed,
    MdGpsOff,
} from "react-icons/md";

import {
    IoIosCopy,
} from "react-icons/io";

import RoomIcon from "@mui/icons-material/Route";

import api from "../../../services/api";

import googleMapsUrl from "../../GoogleMaps/GoogleMaps";

import "./produtividade.scss";

import "react-datepicker/dist/react-datepicker.css";
import { Zoom } from "react-toastify";


// ============================================================
// LOCALIZAÇÃO
// ============================================================

registerLocale(
    "pt-BR",
    ptBRDateFns
);

setDefaultLocale(
    "pt-BR"
);


// ============================================================
// CACHE DOS ÍCONES DO MAPA
// ============================================================

const produtividadeIconCache = {};


// ============================================================
// GERAR ÍCONE DO GOOGLE MAPS
// ============================================================

function getProdutividadeIcon(svg) {

    if (
        !produtividadeIconCache[svg]
    ) {

        produtividadeIconCache[svg] = {

            url:
                "data:image/svg+xml;charset=UTF-8," +
                encodeURIComponent(svg),

            scaledSize:
                new window.google.maps.Size(
                    80,
                    50
                ),

        };

    }

    return produtividadeIconCache[svg];

}


// ============================================================
// FOOTER DA TABELA
// ============================================================


function ProdutividadeFooter({
    kmTotal,
    ehHO,
    horasTotal,
    formatarHoras,
}) {
    return (
        <GridFooterContainer
            sx={{
                background: "#12384d",
                borderTop: "1px solid #1e4f63",
                px: 2,
                minHeight: 58,
            }}
        >
            <div className="produtividade-grid-footer">
                <div className="produtividade-grid-footer-distance">

                </div>

                <GridPagination />
            </div>
        </GridFooterContainer>
    );
}



// ============================================================
// COMPONENTE PRINCIPAL
// ============================================================

function RelatorioProdutividade() {


    // ==========================================================
    // GRUPO
    // ==========================================================

    const [grupo, setGrupo] = useState(null);

    const [opcoesGrupos, setOpcoesGrupos] = useState([]);

    const [inputValueGrupo, setInputValueGrupo] = useState("");

    const [todosVeiculosSelecionados, setTodosVeiculosSelecionados] =
        useState(false);

    const [veiculosSelecionados, setVeiculosSelecionados] = useState([]);
    const [gruposSelecionados, setGruposSelecionados] = useState([]);
    const tabelaRef = useRef(null);


    // ==========================================================
    // DATA ATUAL
    // ==========================================================

    const hoje =
        new Date()
            .toISOString()
            .split("T")[0];


    // ==========================================================
    // FILTROS
    // ==========================================================

    const [
        tipoProdutividade,
        setTipoProdutividade,
    ] = useState(
        "resumo"
    );


    const [
        placa,
        setPlaca,
    ] = useState(
        null
    );


    const [
        inputValue,
        setInputValue,
    ] = useState(
        ""
    );


    const [
        de,
        setDe,
    ] = useState(
        hoje
    );


    const [
        ate,
        setAte,
    ] = useState(
        hoje
    );


    const [
        horaDe,
        setHoraDe,
    ] = useState(
        "00:00"
    );


    const [
        horaAte,
        setHoraAte,
    ] = useState(
        "23:59"
    );


    // ==========================================================
    // DADOS
    // ==========================================================

    const [
        dadosRelatorio,
        setDadosRelatorio,
    ] = useState(
        []
    );


    const [
        marcadores,
        setMarcadores,
    ] = useState(
        []
    );


    // ==========================================================
    // CLIENTE
    // ==========================================================

    const [
        clienteNome,
        setClienteNome,
    ] = useState(
        ""
    );


    // ==========================================================
    // LOADING
    // ==========================================================

    const [
        loading,
        setLoading,
    ] = useState(
        true
    );


    const [
        loadingText,
        setLoadingText,
    ] = useState(
        "Carregando relatório de produtividade..."
    );


    // ==========================================================
    // PDF
    // ==========================================================

    const [
        pdfHabilitado,
        setPdfHabilitado,
    ] = useState(
        false
    );



    // ==========================================================
    // ERROS
    // ==========================================================

    const [
        erroHoraDe,
        setErroHoraDe,
    ] = useState(
        ""
    );


    const [
        erroHoraAte,
        setErroHoraAte,
    ] = useState(
        ""
    );

    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);

    const operacaoEmAndamento =
        loading || loadingExcel || loadingPDF;

    // ==========================================================
    // OPÇÕES DO TIPO DE RELATÓRIO
    // ==========================================================
    // =======================================================
    // TIPO DE MEDIÇÃO
    // =======================================================

    const produtividadeMedicaoOptions = [

        {
            value: "km",
            label: "Quilometragem",
        },

        {
            value: "ho",
            label: "Horímetro",
        },

    ];


    // =======================================================
    // TIPO DE RELATÓRIO
    // =======================================================

    const produtividadeTipoOptions = [

        {
            value: "resumo",
            label: "KM Resumo",
            medicao: "km",
        },

        {
            value: "detalhado",
            label: "KM Detalhado",
            medicao: "km",
        },

        {
            value: "ho_resumo",
            label: "Horas Resumo",
            medicao: "ho",
        },

        {
            value: "ho_detalhado",
            label: "Horas Detalhado",
            medicao: "ho",
        },

    ];


    // =======================================================
    // ESTADO DA MEDIÇÃO
    // =======================================================

    const [tipoMedicao, setTipoMedicao] = useState(null);


    // =======================================================
    // OPÇÕES DO SEGUNDO SELECT
    // =======================================================

    const produtividadeTipoFiltrado =
        produtividadeTipoOptions.filter(
            (item) =>
                item.medicao === tipoMedicao
        );


    // =======================================================
    // LABEL DO RELATÓRIO
    // =======================================================

    function getProdutividadeTipoLabel(tipo) {

        const opcao =
            produtividadeTipoOptions.find(
                (item) =>
                    item.value === tipo
            );

        return (
            opcao?.label ||
            "-"
        );

    }


    // =======================================================
    // IDENTIFICADORES
    // =======================================================

    const ehHO =
        tipoMedicao === "ho";

    const ehKM =
        tipoMedicao === "km";




    // ==========================================================
    // BODY
    // ==========================================================

    useEffect(() => {

        document.body.classList.add(
            "body-produtividade"
        );

        return () => {

            document.body.classList.remove(
                "body-produtividade"
            );

        };

    }, []);


    // ==========================================================
    // RECUPERAR VEÍCULO
    // ==========================================================

    useEffect(() => {

        const dadosVeiculo =
            sessionStorage.getItem(
                "relatorio_veiculo"
            );

        if (
            !dadosVeiculo
        ) {

            return;

        }


        try {

            const veiculo =
                JSON.parse(
                    dadosVeiculo
                );


            if (
                veiculo?.placa
            ) {

                setPlaca({

                    value:
                        veiculo.placa,

                    label:
                        veiculo.placa,

                    placa:
                        veiculo.placa,

                    nome:
                        veiculo.descricao ||
                        "",

                });

            }

        } catch (
        error
        ) {

            console.error(
                "Erro ao recuperar veículo:",
                error
            );

        }

    }, []);


    // ==========================================================
    // BUSCAR VEÍCULOS
    // ==========================================================

    useEffect(() => {

        async function carregarVeiculos() {

            try {

                const id =
                    localStorage.getItem(
                        "id"
                    );


                if (
                    !id
                ) {

                    setLoading(
                        false
                    );

                    return;

                }


                const response =
                    await api.get(
                        `/relatorioListInfo/${id}`,
                        {
                            headers: {
                                typo:
                                    id,
                            },
                        }
                    );


                const data =
                    Array.isArray(
                        response.data
                    )
                        ? response.data
                        : [];

                console.log(
                    "[PRODUTIVIDADE] DADOS RELATORIO LIST INFO:",
                    data
                );


                setMarcadores(
                    data
                );


                if (
                    data.length
                ) {

                    setClienteNome(
                        data[0]?.nome ||
                        ""
                    );

                }

            } catch (
            error
            ) {

                console.error(
                    "Erro ao carregar veículos:",
                    error
                );

            } finally {

                setLoading(
                    false
                );

            }

        }


        carregarVeiculos();

    }, []);


    // ==========================================================
    // CARREGAR GRUPOS
    // ==========================================================

    useEffect(() => {

        async function carregarGrupos() {

            try {

                console.log(
                    "[PRODUTIVIDADE] Carregando grupos..."
                );


                const response = await api.get(
                    "/produtividade/km-resumo",
                    {
                        params: {
                            listarGrupos: true
                        }
                    }
                );


                const grupos =
                    response?.data?.grupos || [];


                console.log(
                    "[PRODUTIVIDADE] Grupos encontrados:",
                    grupos
                );


                setOpcoesGrupos(

                    grupos.map((item) => ({

                        value: item.id,

                        label: item.nome,

                        id: item.id,

                        nome: item.nome,

                    }))

                );


            } catch (error) {

                console.error(
                    "[PRODUTIVIDADE] Erro ao carregar grupos:",
                    error
                );


                setOpcoesGrupos([]);

            }

        }


        carregarGrupos();

    }, []);


    // ==========================================================
    // OPÇÕES DOS VEÍCULOS
    // ==========================================================

    const opcoesVeiculos =
        useMemo(
            () => {

                return marcadores.map(
                    (
                        item
                    ) => ({

                        value:
                            item.placa,

                        label:
                            item.placa,

                        placa:
                            item.placa,

                        nome:
                            item.nome ||
                            item.descricao ||
                            "",

                    })
                );

            },
            [
                marcadores,
            ]
        );


    // ==========================================================
    // FILTRO DOS VEÍCULOS
    // ==========================================================

    const filterOption =
        (
            option,
            rawInput
        ) => {

            const busca =
                String(
                    rawInput ||
                    ""
                )
                    .toLowerCase()
                    .trim();


            if (
                !busca
            ) {

                return true;

            }


            const placaOption =
                String(
                    option?.data?.placa ||
                    option?.data?.value ||
                    ""
                )
                    .toLowerCase();


            const nomeOption =
                String(
                    option?.data?.nome ||
                    ""
                )
                    .toLowerCase();


            return (
                placaOption.includes(
                    busca
                ) ||
                nomeOption.includes(
                    busca
                )
            );

        };


    // ==========================================================
    // ESTILO SELECT
    // ==========================================================

    const selectDarkStyles = {

        control: (
            provided,
            state
        ) => ({

            ...provided,

            minHeight:
                "42px",

            height:
                "42px",

            background:
                "#0b1e2d",

            border:
                state.isFocused
                    ? "1px solid #38BDF8"
                    : "1px solid #29485a",

            boxShadow:
                "none",

            borderRadius:
                "7px",

            "&:hover": {

                border:
                    "1px solid #38BDF8",

            },

        }),


        valueContainer: (
            provided
        ) => ({

            ...provided,

            padding:
                "0 12px",

        }),


        singleValue: (
            provided
        ) => ({

            ...provided,

            color:
                "#f8fafc",

            fontSize:
                "13px",

        }),


        placeholder: (
            provided
        ) => ({

            ...provided,

            color:
                "#64748b",

            fontSize:
                "13px",

        }),


        input: (
            provided
        ) => ({

            ...provided,

            color:
                "#fff",

        }),


        menu: (
            provided
        ) => ({

            ...provided,

            background:
                "#0b1e2d",

            border:
                "1px solid #29485a",

            zIndex:
                99999,

        }),


        menuList: (
            provided
        ) => ({

            ...provided,

            background:
                "#0b1e2d",

            padding:
                "5px",

        }),


        option: (
            provided,
            state
        ) => ({

            ...provided,

            background:
                state.isSelected
                    ? "#0b73b5"
                    : state.isFocused
                        ? "#12384d"
                        : "#0b1e2d",

            color:
                "#fff",

            cursor:
                "pointer",

            fontSize:
                "13px",

            borderRadius:
                "5px",

        }),


        indicatorSeparator: (
            provided
        ) => ({

            ...provided,

            background:
                "#29485a",

        }),


        dropdownIndicator: (
            provided
        ) => ({

            ...provided,

            color:
                "#64748b",

        }),

    };


    // ==========================================================
    // FORMATA DATA
    // ==========================================================

    function formatarData(
        valor
    ) {

        if (
            !valor
        ) {

            return "-";

        }


        try {

            return format(
                new Date(
                    valor
                ),
                "dd/MM/yyyy"
            );

        } catch {

            return "-";

        }

    }


    // ==========================================================
    // FORMATA DATA + HORA
    // ==========================================================

    function formatarDataHora(
        valor
    ) {

        if (
            !valor
        ) {

            return "-";

        }


        try {

            return format(
                new Date(
                    valor
                ),
                "dd/MM/yyyy HH:mm:ss"
            );

        } catch {

            return "-";

        }

    }


    // ==========================================================
    // FORMATAR KM
    // ==========================================================

    function formatarKm(
        valor
    ) {

        const numero =
            Number(
                valor
            );


        if (
            !Number.isFinite(
                numero
            )
        ) {

            return "-";

        }


        return numero.toLocaleString(
            "pt-BR",
            {
                minimumFractionDigits:
                    2,

                maximumFractionDigits:
                    2,
            }
        );

    }


    // ==========================================================
    // FORMATAR COORDENADA
    // ==========================================================

    function formatarCoordenada(
        valor
    ) {

        const numero =
            Number(
                valor
            );


        if (
            !Number.isFinite(
                numero
            )
        ) {

            return "-";

        }


        return numero.toFixed(
            6
        );

    }


    // ==========================================================
    // KM TOTAL
    // ==========================================================
    //
    // RESUMO:
    // soma o hodometro_total retornado.
    //
    // DETALHADO:
    // soma os hodometro_total de cada dia.
    //
    // ==========================================================

    const kmTotal =
        useMemo(
            () => {

                return dadosRelatorio.reduce(
                    (
                        total,
                        item
                    ) => {

                        const valor =
                            Number(
                                item.hodometro_total
                            );


                        if (
                            !Number.isFinite(
                                valor
                            )
                        ) {

                            return total;

                        }


                        return (
                            total +
                            valor
                        );

                    },
                    0
                );

            },
            [
                dadosRelatorio,
            ]
        );


    // ==========================================================
    // VALIDAR HORÁRIO
    // ==========================================================

    function validarHora(
        valor
    ) {

        if (
            !valor
        ) {

            return false;

        }


        const regex =
            /^([01]\d|2[0-3]):([0-5]\d)$/;


        return regex.test(
            valor
        );

    }


    // ==========================================================
    // FORMATAR HORA AUTOMATICAMENTE
    // ==========================================================

    function formatarHoraInput(
        valor
    ) {

        let numero =
            String(
                valor ||
                ""
            )
                .replace(
                    /\D/g,
                    ""
                )
                .slice(
                    0,
                    4
                );


        if (
            numero.length >= 3
        ) {

            numero =
                numero.slice(
                    0,
                    2
                ) +
                ":" +
                numero.slice(
                    2
                );

        }


        return numero;

    }


    // ==========================================================
    // ALTERAR HORA INICIAL
    // ==========================================================

    function handleHoraDeChange(
        event
    ) {

        const valor =
            formatarHoraInput(
                event.target.value
            );


        setHoraDe(
            valor
        );


        if (
            valor.length === 5 &&
            !validarHora(
                valor
            )
        ) {

            setErroHoraDe(
                "Informe um horário entre 00:00 e 23:59."
            );

        } else {

            setErroHoraDe(
                ""
            );

        }

    }


    // ==========================================================
    // ALTERAR HORA FINAL
    // ==========================================================

    function handleHoraAteChange(
        event
    ) {

        const valor =
            formatarHoraInput(
                event.target.value
            );


        setHoraAte(
            valor
        );


        if (
            valor.length === 5 &&
            !validarHora(
                valor
            )
        ) {

            setErroHoraAte(
                "Informe um horário entre 00:00 e 23:59."
            );

        } else {

            setErroHoraAte(
                ""
            );

        }

    }


    // ==========================================================
    // CONSULTAR BACKEND
    // ==========================================================
    //
    // ESTE É O ÚNICO LOCAL QUE VOCÊ PRECISA LIGAR AO CONTROLLER.
    //
    // KM RESUMO:
    //    /produtividade/km-resumo
    //
    // KM DETALHADO:
    //    /produtividade/km-detalhado
    //
    // ==========================================================


async function consultarProdutividade() {
    // ==========================================================
    // 1. IDENTIFICAR GRUPOS SELECIONADOS
    // ==========================================================

    const gruposParaConsulta = Array.isArray(gruposSelecionados)
        ? gruposSelecionados
        : [];

    const temGruposSelecionados =
        gruposParaConsulta.length > 0;

    const temGrupoIndividual =
        Boolean(grupo?.value);

    const temPlacaIndividual =
        Boolean(placa?.value);

    const temVeiculosSelecionados =
        Array.isArray(veiculosSelecionados) &&
        veiculosSelecionados.length > 0;

    // ==========================================================
    // 2. VALIDAR VEÍCULO OU GRUPO
    // ==========================================================

    if (
        !temPlacaIndividual &&
        !temGrupoIndividual &&
        !temGruposSelecionados &&
        !temVeiculosSelecionados &&
        !todosVeiculosSelecionados
    ) {
        throw new Error(
            "Selecione uma placa, um grupo, vários grupos, vários veículos ou todos os veículos."
        );
    }

    // ==========================================================
    // 3. VALIDAR HORÁRIOS
    // ==========================================================

    if (!validarHora(horaDe)) {
        throw new Error("A hora inicial é inválida.");
    }

    if (!validarHora(horaAte)) {
        throw new Error("A hora final é inválida.");
    }

    // ==========================================================
    // 4. VALIDAR PERÍODO
    // ==========================================================

    const dataInicial = new Date(`${de}T${horaDe}:00`);
    const dataFinal = new Date(`${ate}T${horaAte}:59`);

    if (
        Number.isNaN(dataInicial.getTime()) ||
        Number.isNaN(dataFinal.getTime())
    ) {
        throw new Error(
            "A data inicial ou final é inválida."
        );
    }

    if (dataFinal < dataInicial) {
        throw new Error(
            "O período final não pode ser menor que o período inicial."
        );
    }

    // ==========================================================
    // 5. DEFINIR ENDPOINT
    // ==========================================================

    let endpoint;

    if (
        tipoProdutividade === "resumo" ||
        tipoProdutividade === "ho_resumo"
    ) {
        endpoint = "/produtividade/km-resumo";
    } else if (
        tipoProdutividade === "detalhado" ||
        tipoProdutividade === "ho_detalhado"
    ) {
        endpoint = "/produtividade/km-detalhado";
    } else {
        throw new Error("Tipo de relatório inválido.");
    }

    // ==========================================================
    // 6. MONTAR PARÂMETROS
    // ==========================================================

    const params = {
        de,
        ate,
        horaDe,
        horaAte,
    };

    if (todosVeiculosSelecionados) {
        // ==========================================
        // TODOS OS VEÍCULOS
        // ==========================================

        params.todosVeiculosSelecionados = "true";

    } else if (temGruposSelecionados) {
        // ==========================================
        // MÚLTIPLOS GRUPOS
        // ==========================================

        const idsGrupos = gruposParaConsulta
            .map((item) => item?.value ?? item?.id ?? item)
            .filter(
                (id) =>
                    id !== undefined &&
                    id !== null &&
                    id !== ""
            )
            .map(String);

        if (idsGrupos.length === 0) {
            throw new Error(
                "Não foi possível identificar os IDs dos grupos selecionados."
            );
        }

        params.grupos = JSON.stringify(idsGrupos);
        params.todosVeiculosSelecionados = "false";

    } else if (temGrupoIndividual) {
        // ==========================================
        // GRUPO INDIVIDUAL DO SELECT
        // ==========================================

        const idGrupo = grupo.value;

        if (
            idGrupo === undefined ||
            idGrupo === null ||
            String(idGrupo).trim() === ""
        ) {
            throw new Error(
                "Não foi possível identificar o ID do grupo selecionado."
            );
        }

        params.grupo = String(idGrupo);
        params.todosVeiculosSelecionados = "false";

    } else if (temVeiculosSelecionados) {
        // ==========================================
        // MÚLTIPLAS PLACAS
        // ==========================================

        const placas = veiculosSelecionados
            .map((veiculo) => veiculo?.value)
            .filter(Boolean);

        if (placas.length === 0) {
            throw new Error(
                "Não foi possível identificar as placas selecionadas."
            );
        }

        params.placas = JSON.stringify(placas);
        params.todosVeiculosSelecionados = "false";

    } else if (temPlacaIndividual) {
        // ==========================================
        // PLACA INDIVIDUAL
        // ==========================================

        params.placa = placa.value;
        params.todosVeiculosSelecionados = "false";
    }

    // ==========================================================
    // 7. LOGS PARA DEPURAÇÃO
    // ==========================================================

    console.log(
        "[PRODUTIVIDADE] Placa individual:",
        placa
    );

    console.log(
        "[PRODUTIVIDADE] Grupo individual:",
        grupo
    );

    console.log(
        "[PRODUTIVIDADE] Grupos múltiplos:",
        gruposParaConsulta
    );

    console.log(
        "[PRODUTIVIDADE] Veículos selecionados:",
        veiculosSelecionados
    );

    console.log(
        "[PRODUTIVIDADE] Todos os veículos:",
        todosVeiculosSelecionados
    );

    console.log(
        "[PRODUTIVIDADE] Parâmetros enviados:",
        params
    );

    console.log(
        "[PRODUTIVIDADE] Endpoint:",
        endpoint
    );

    // ==========================================================
    // 8. CONSULTAR API
    // ==========================================================

    const response = await api.get(endpoint, {
        params,
    });

    console.log(
        "[PRODUTIVIDADE] Resposta recebida:",
        response?.data
    );

    // ==========================================================
    // 9. RETORNAR DADOS
    // ==========================================================

    return response?.data?.data ?? response?.data ?? [];
}


    // ==========================================================
    // CONSULTAR
    // ==========================================================

    // ==========================================================
    // CONSULTAR RELATÓRIO
    // ==========================================================
    //
    // A consulta pode ser feita por:
    //
    // 1. PLACA
    // 2. GRUPO
    //
    // O loader somente será ativado depois que a validação
    // de placa/grupo e dos horários passar.
    // ==========================================================




async function validarEConsultarRelatorio() {
    // ==========================================================
    // 1. VALIDAR PLACA, GRUPO INDIVIDUAL, GRUPOS MÚLTIPLOS,
    //    MÚLTIPLOS VEÍCULOS OU TODOS OS VEÍCULOS
    // ==========================================================

    const temGruposSelecionados =
        Array.isArray(gruposSelecionados) &&
        gruposSelecionados.length > 0;

    const temGrupoIndividual =
        Boolean(grupo?.value);

    const temPlacaIndividual =
        Boolean(placa?.value);

    const temVeiculosSelecionados =
        Array.isArray(veiculosSelecionados) &&
        veiculosSelecionados.length > 0;

    const temTodosVeiculos =
        Boolean(todosVeiculosSelecionados);

    if (
        !temPlacaIndividual &&
        !temGrupoIndividual &&
        !temGruposSelecionados &&
        !temVeiculosSelecionados &&
        !temTodosVeiculos
    ) {
        await Swal.fire({
            icon: "error",
            title: "Erro ao consultar relatório",
            text:
                "Selecione uma placa, um grupo, vários grupos, vários veículos ou todos os veículos.",
            background: "#0b1f2d",
            color: "#fff",
            confirmButtonText: "Entendi",
        });

        return null;
    }

    // ==========================================================
    // 2. VALIDAR PERÍODO
    // ==========================================================

    const periodoValido =
        await validarPeriodoRelatorio();

    if (!periodoValido) {
        return null;
    }

    // ==========================================================
    // 3. CONSULTAR RELATÓRIO
    // ==========================================================

    try {
        setLoading(true);

        setLoadingText(
            "Consultando relatório de produtividade..."
        );

        const dados =
            await consultarProdutividade();

        const resultado = Array.isArray(dados)
            ? dados
            : [];

        // ======================================================
        // 4. NENHUM REGISTRO ENCONTRADO
        // ======================================================

        if (resultado.length === 0) {
            await Swal.fire({
                icon: "info",
                title: "Nenhum registro encontrado",
                text:
                    "Não existem dados para os filtros selecionados.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Entendi",
            });

            return null;
        }

        // ======================================================
        // 5. RETORNAR RESULTADOS
        // ======================================================

        return resultado;

    } catch (error) {
        console.error(
            "[PRODUTIVIDADE] ERRO DETALHADO:",
            {
                status: error?.response?.status,
                resposta: error?.response?.data,
                mensagem: error?.message,
            }
        );

        await Swal.fire({
            icon: "error",
            title: "Erro ao consultar relatório",
            text:
                error?.response?.data?.erro ||
                error?.response?.data?.message ||
                error?.message ||
                "Não foi possível consultar o relatório.",
            background: "#0b1f2d",
            color: "#fff",
            confirmButtonText: "Entendi",
        });

        return null;

    } finally {
        setLoading(false);
    }
}


    // ==========================================================
    // HANDLE SUBMIT
    // ==========================================================

    async function handleSubmit(event) {
        if (event) {
            event.preventDefault();
        }

        try {
            const resultado =
                await validarEConsultarRelatorio();

            if (resultado === null) {
                setDadosRelatorio([]);
                setPdfHabilitado(false);
                return;
            }

            setDadosRelatorio(resultado);
            setPdfHabilitado(resultado.length > 0);

            // ==========================================
            // SCROLL SUAVE ATÉ A TABELA
            // ==========================================

            if (resultado.length > 0) {
                setTimeout(() => {
                    tabelaRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }, 100);
            }

        } catch (error) {
            console.error(
                "Erro ao consultar relatório:",
                error
            );

            setDadosRelatorio([]);
            setPdfHabilitado(false);
        }
    }














    // ==========================================================
    // COPIAR TEXTO
    // ==========================================================

    async function copiarTexto(
        texto
    ) {

        try {

            await navigator.clipboard.writeText(
                String(
                    texto ||
                    ""
                )
            );


            Swal.fire({

                icon:
                    "success",

                title:
                    "Copiado",

                text:
                    "Informação copiada para a área de transferência.",

                timer:
                    1300,

                showConfirmButton:
                    false,

                background:
                    "#0b1f2d",

                color:
                    "#fff",

            });

        } catch (
        error
        ) {

            console.error(
                error
            );

        }

    }











    // ==========================================================
    // COLUNAS RESUMO
    // ==========================================================

    const columnsResumo = [
        // ==========================================================
        // PLACA
        // ==========================================================
        {
            field: "placa",
            headerName: "Placa",
            width: 100,
            headerAlign: "center",
            align: "center",
        },

        // ==========================================================
        // DESCRIÇÃO
        // ==========================================================
        {
            field: "nome",
            headerName: "Descrição",
            width: 220,
            headerAlign: "center",
            align: "center",
        },

        // ==========================================================
        // GRUPO
        // ==========================================================
        {
            field: "grupo",
            headerName: "Grupo",
            width: 140,
            headerAlign: "center",
            align: "center",
        },

        // ==========================================================
        // INÍCIO
        // ==========================================================
        {
            field: "data_hora_inicial",
            headerName: "Início",
            width: 180,
            headerAlign: "center",
            align: "center",

            renderCell: (params) =>
                formatarDataHora(params.value),
        },

        // ==========================================================
        // FIM
        // ==========================================================
        {
            field: "data_hora_final",
            headerName: "Fim",
            width: 180,
            headerAlign: "center",
            align: "center",

            renderCell: (params) =>
                formatarDataHora(params.value),
        },

        // ==========================================================
        // COLUNAS DE PRODUTIVIDADE
        //
        // KM:
        //   Hodômetro Início
        //   Hodômetro Fim
        //   Total de KM
        //
        // HO:
        //   Horímetro Início
        //   Horímetro Fim
        //   Total de Horas Trabalhadas
        // ==========================================================

        ...(ehHO
            ? [
                // ==================================================
                // HORÍMETRO INÍCIO
                // ==================================================
                {
                    field: "horimetro_inicial",
                    headerName: "Horímetro Início",
                    width: 150,
                    headerAlign: "center",
                    align: "center",

                    renderCell: (params) => {
                        const valor = Number(params.value);

                        if (!Number.isFinite(valor)) {
                            return "-";
                        }

                        return valor.toFixed(1);
                    },
                },

                // ==================================================
                // HORÍMETRO FIM
                // ==================================================
                {
                    field: "horimetro_final",
                    headerName: "Horímetro Fim",
                    width: 150,
                    headerAlign: "center",
                    align: "center",

                    renderCell: (params) => {
                        const valor = Number(params.value);

                        if (!Number.isFinite(valor)) {
                            return "-";
                        }

                        return valor.toFixed(1);
                    },
                },

                // ==================================================
                // TOTAL DE HORAS TRABALHADAS
                // ==================================================
                {
                    field: "total_horas_trabalhadas",
                    headerName: "Total de Horas Trabalhadas",
                    width: 220,
                    headerAlign: "center",
                    align: "center",

                    renderCell: (params) => {
                        const inicio = Number(
                            params.row?.horimetro_inicial
                        );

                        const fim = Number(
                            params.row?.horimetro_final
                        );

                        // ------------------------------------------
                        // Validação
                        // ------------------------------------------
                        if (
                            !Number.isFinite(inicio) ||
                            !Number.isFinite(fim)
                        ) {
                            return "-";
                        }

                        // ------------------------------------------
                        // Diferença do horímetro
                        // ------------------------------------------
                        const totalHoras = fim - inicio;

                        if (totalHoras < 0) {
                            return "-";
                        }

                        // ------------------------------------------
                        // Converte horas para minutos
                        // ------------------------------------------
                        const totalMinutos = Math.round(
                            totalHoras * 60
                        );

                        // ------------------------------------------
                        // Calcula dias
                        // ------------------------------------------
                        const dias = Math.floor(
                            totalMinutos / (24 * 60)
                        );

                        // ------------------------------------------
                        // Calcula o restante de minutos
                        // ------------------------------------------
                        const minutosRestantes =
                            totalMinutos % (24 * 60);

                        // ------------------------------------------
                        // Calcula horas
                        // ------------------------------------------
                        const horas = Math.floor(
                            minutosRestantes / 60
                        );

                        // ------------------------------------------
                        // Calcula minutos
                        // ------------------------------------------
                        const minutos =
                            minutosRestantes % 60;

                        // ------------------------------------------
                        // Mais de 24 horas
                        // ------------------------------------------
                        if (dias > 0) {
                            return `${dias} dia${dias !== 1 ? "s" : ""
                                } ${horas}h ${minutos}min`;
                        }

                        // ------------------------------------------
                        // Menos de 24 horas
                        // ------------------------------------------
                        return `${horas}h ${minutos}min`;
                    },
                },
            ]
            : [
                // ==================================================
                // HODÔMETRO INÍCIO
                // ==================================================
                {
                    field: "hodometro_inicial",
                    headerName: "Hodômetro Início",
                    width: 150,
                    headerAlign: "center",
                    align: "center",

                    renderCell: (params) =>
                        formatarKm(params.value),
                },

                // ==================================================
                // HODÔMETRO FIM
                // ==================================================
                {
                    field: "hodometro_final",
                    headerName: "Hodômetro Fim",
                    width: 150,
                    headerAlign: "center",
                    align: "center",

                    renderCell: (params) =>
                        formatarKm(params.value),
                },

                // ==================================================
                // TOTAL DE KM
                // ==================================================
                {
                    field: "hodometro_total",
                    headerName: "Total de KM",
                    width: 150,
                    headerAlign: "center",
                    align: "center",

                    renderCell: (params) => (
                        <strong className="produtividade-km-total">
                            {formatarKm(params.value)}
                            {" km"}
                        </strong>
                    ),
                },
            ]),

        // ==========================================================
        // ENDEREÇO INICIAL
        // ==========================================================
        {
            field: "endereco_inicial",
            headerName: "Endereço Inicial",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            align: "left",
        },

        // ==========================================================
        // ENDEREÇO FINAL
        // ==========================================================
        {
            field: "endereco_final",
            headerName: "Endereço Final",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            align: "left",
        },

        // ==========================================================
        // AÇÕES
        // ==========================================================
        {
            field: "acoes",
            headerName: "Ações",
            width: 120,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center",

            renderCell: (params) => {
                const row = params.row;

                // ==================================================
                // TEXTO PARA COPIAR
                // ==================================================
                let texto = `
                Placa: ${row.placa || "-"}

                Início:
                ${formatarDataHora(row.data_hora_inicial)}

                Fim:
                ${formatarDataHora(row.data_hora_final)}
                `;

                // ==================================================
                // SE FOR HO
                // ==================================================
                if (ehHO) {
                    const inicio = Number(
                        row.horimetro_inicial
                    );

                    const fim = Number(
                        row.horimetro_final
                    );

                    let totalHorasTexto = "-";

                    if (
                        Number.isFinite(inicio) &&
                        Number.isFinite(fim)
                    ) {
                        const totalHoras = fim - inicio;

                        if (totalHoras >= 0) {
                            const totalMinutos = Math.round(
                                totalHoras * 60
                            );

                            const dias = Math.floor(
                                totalMinutos / (24 * 60)
                            );

                            const minutosRestantes =
                                totalMinutos % (24 * 60);

                            const horas = Math.floor(
                                minutosRestantes / 60
                            );

                            const minutos =
                                minutosRestantes % 60;

                            if (dias > 0) {
                                totalHorasTexto = `${dias} dia${dias !== 1 ? "s" : ""
                                    } ${horas}h ${minutos}min`;
                            } else {
                                totalHorasTexto = `${horas}h ${minutos}min`;
                            }
                        }
                    }

                    texto += `
                        Horímetro inicial:
                        ${Number.isFinite(inicio) ? inicio.toFixed(1) : "-"}

                        Horímetro final:
                        ${Number.isFinite(fim) ? fim.toFixed(1) : "-"}

                        Total de Horas Trabalhadas:
                        ${totalHorasTexto}
                        `;
                }

                // ==================================================
                // SE FOR KM
                // ==================================================
                else {
                    texto += `
                    KM inicial:
                    ${formatarKm(row.hodometro_inicial)}

                    KM final:
                    ${formatarKm(row.hodometro_final)}

                    KM percorrido:
                    ${formatarKm(row.hodometro_total)}
                    `;
                }

                // ==================================================
                // ENDEREÇOS
                // ==================================================
                texto += `
                Endereço inicial:
                ${row.endereco_inicial || "-"}

                Endereço final:
                ${row.endereco_final || "-"}
                `.trim();

                // ==================================================
                // BOTÃO COPIAR
                // ==================================================
                return (
                    <button
                        type="button"
                        className="produtividade-copy-button"
                        onClick={() =>
                            copiarTexto(texto)
                        }
                        title="Copiar"
                    >
                        <IoIosCopy size={17} />
                    </button>
                );
            },
        },
    ];


    // ==========================================================
    // COLUNAS KM DETALHADO
    // ==========================================================

    const columnsDetalhado = [



        // ==========================================================
        // PLACA
        // ==========================================================
        {
            field: "placa",

            headerName: "Placa",

            width: 100,

            headerAlign: "center",

            align: "center",
        },


        // ==========================================================
        // DESCRIÇÃO
        // ==========================================================
        {
            field: "nome",

            headerName: "Descrição",

            width: 220,

            headerAlign: "center",

            align: "center",
        },


        // ==========================================================
        // GRUPO
        // ==========================================================
        {
            field: "grupo",

            headerName: "Grupo",

            width: 140,

            headerAlign: "center",

            align: "center",
        },



        // ==========================================================
        // INÍCIO
        // ==========================================================
        {
            field: "data_hora_inicial",

            headerName: "Início",

            width: 180,

            headerAlign: "center",

            align: "center",

            renderCell: (params) =>
                formatarDataHora(
                    params.value
                ),
        },


        // ==========================================================
        // FIM
        // ==========================================================
        {
            field: "data_hora_final",

            headerName: "Fim",

            width: 180,

            headerAlign: "center",

            align: "center",

            renderCell: (params) =>
                formatarDataHora(
                    params.value
                ),
        },


        // ==========================================================
        // COLUNAS DE PRODUTIVIDADE
        //
        // KM:
        //   Hodômetro Início
        //   Hodômetro Fim
        //   Total de KM
        //
        // HO:
        //   Horímetro Início
        //   Horímetro Fim
        //   Total de Horas Trabalhadas
        // ==========================================================

        ...(ehHO
            ? [

                // ==================================================
                // HORÍMETRO INÍCIO
                // ==================================================
                {
                    field:
                        "horimetro_inicial",

                    headerName:
                        "Horímetro Início",

                    width:
                        150,

                    headerAlign:
                        "center",

                    align:
                        "center",

                    renderCell:
                        (params) => {

                            const valor =
                                Number(
                                    params.value
                                );

                            if (
                                !Number.isFinite(
                                    valor
                                )
                            ) {
                                return "-";
                            }

                            return valor.toFixed(1);

                        },
                },


                // ==================================================
                // HORÍMETRO FIM
                // ==================================================
                {
                    field:
                        "horimetro_final",

                    headerName:
                        "Horímetro Fim",

                    width:
                        150,

                    headerAlign:
                        "center",

                    align:
                        "center",

                    renderCell:
                        (params) => {

                            const valor =
                                Number(
                                    params.value
                                );

                            if (
                                !Number.isFinite(
                                    valor
                                )
                            ) {
                                return "-";
                            }

                            return valor.toFixed(1);

                        },
                },


                // ==================================================
                // TOTAL DE HORAS TRABALHADAS
                // ==================================================
                {
                    field:
                        "total_horas_trabalhadas",

                    headerName:
                        "Total de Horas Trabalhadas",

                    width:
                        220,

                    headerAlign:
                        "center",

                    align:
                        "center",

                    renderCell:
                        (params) => {

                            const inicio =
                                Number(
                                    params.row
                                        ?.horimetro_inicial
                                );

                            const fim =
                                Number(
                                    params.row
                                        ?.horimetro_final
                                );

                            // --------------------------------------
                            // VALIDAÇÃO
                            // --------------------------------------
                            if (
                                !Number.isFinite(
                                    inicio
                                ) ||
                                !Number.isFinite(
                                    fim
                                )
                            ) {
                                return "-";
                            }

                            // --------------------------------------
                            // DIFERENÇA DO HORÍMETRO
                            // --------------------------------------
                            const totalHoras =
                                fim - inicio;

                            if (
                                totalHoras < 0
                            ) {
                                return "-";
                            }

                            // --------------------------------------
                            // USA A FUNÇÃO QUE VOCÊ JÁ POSSUI
                            // --------------------------------------
                            return formatarHoras(
                                totalHoras
                            );

                        },
                },

            ]

            : [

                // ==================================================
                // HODÔMETRO INÍCIO
                // ==================================================
                {
                    field:
                        "hodometro_inicial",

                    headerName:
                        "Hodômetro Início",

                    width:
                        150,

                    headerAlign:
                        "center",

                    align:
                        "center",

                    renderCell:
                        (params) =>
                            formatarKm(
                                params.value
                            ),
                },


                // ==================================================
                // HODÔMETRO FIM
                // ==================================================
                {
                    field:
                        "hodometro_final",

                    headerName:
                        "Hodômetro Fim",

                    width:
                        150,

                    headerAlign:
                        "center",

                    align:
                        "center",

                    renderCell:
                        (params) =>
                            formatarKm(
                                params.value
                            ),
                },


                // ==================================================
                // TOTAL DE KM
                // ==================================================
                {
                    field:
                        "hodometro_total",

                    headerName:
                        "Total de KM",

                    width:
                        150,

                    headerAlign:
                        "center",

                    align:
                        "center",

                    renderCell:
                        (params) => (

                            <strong
                                className="produtividade-km-total"
                            >
                                {formatarKm(
                                    params.value
                                )}

                                {" km"}

                            </strong>

                        ),
                },

            ]),


        // ==========================================================
        // ENDEREÇO INICIAL
        // ==========================================================
        {
            field:
                "endereco_inicial",

            headerName:
                "Endereço Inicial",

            minWidth:
                300,

            flex:
                1,

            headerAlign:
                "center",

            align:
                "left",
        },


        // ==========================================================
        // ENDEREÇO FINAL
        // ==========================================================
        {
            field:
                "endereco_final",

            headerName:
                "Endereço Final",

            minWidth:
                300,

            flex:
                1,

            headerAlign:
                "center",

            align:
                "left",
        },


        // ==========================================================
        // AÇÕES
        // ==========================================================
        {
            field:
                "acoes",

            headerName:
                "Ações",

            width:
                120,

            sortable:
                false,

            filterable:
                false,

            headerAlign:
                "center",

            align:
                "center",

            renderCell:
                (params) => {

                    const row =
                        params.row;

                    // ==================================================
                    // TEXTO BASE
                    // ==================================================
                    let texto = `

                Data:
                ${formatarData(
                        row.datas_filtro
                    )}

                Placa:
                ${row.placa || "-"}

                Descrição:
                ${row.nome || "-"}

                Grupo:
                ${row.grupo || "-"}

                

                Início:
                ${formatarDataHora(
                        row.data_hora_inicial
                    )}

                Fim:
                ${formatarDataHora(
                        row.data_hora_final
                    )}
                `;


                    // ==================================================
                    // SE FOR HO
                    // ==================================================
                    if (ehHO) {

                        const inicio =
                            Number(
                                row.horimetro_inicial
                            );

                        const fim =
                            Number(
                                row.horimetro_final
                            );

                        let totalHorasTexto =
                            "-";


                        if (
                            Number.isFinite(
                                inicio
                            ) &&
                            Number.isFinite(
                                fim
                            )
                        ) {

                            const totalHoras =
                                fim - inicio;


                            if (
                                totalHoras >= 0
                            ) {

                                totalHorasTexto =
                                    formatarHoras(
                                        totalHoras
                                    );

                            }

                        }


                        texto += `

                    Horímetro inicial:
                    ${Number.isFinite(inicio)
                                ? inicio.toFixed(1)
                                : "-"
                            }

                    Horímetro final:
                    ${Number.isFinite(fim)
                                ? fim.toFixed(1)
                                : "-"
                            }

                    Total de Horas Trabalhadas:
                    ${totalHorasTexto}
                    `;

                    }


                    // ==================================================
                    // SE FOR KM
                    // ==================================================
                    else {

                        texto += `

                    KM inicial:
                    ${formatarKm(
                            row.hodometro_inicial
                        )}

                    KM final:
                    ${formatarKm(
                            row.hodometro_final
                        )}

                    KM percorrido:
                    ${formatarKm(
                            row.hodometro_total
                        )}
                    `;

                    }


                    // ==================================================
                    // ENDEREÇOS
                    // ==================================================
                    texto += `

                Endereço inicial:
                ${row.endereco_inicial || "-"}

                Endereço final:
                ${row.endereco_final || "-"}
                `.trim();


                    // ==================================================
                    // BOTÃO COPIAR
                    // ==================================================
                    return (

                        <button
                            type="button"

                            className="produtividade-copy-button"

                            title="Copiar dados"

                            onClick={() =>
                                copiarTexto(
                                    texto
                                )
                            }
                        >

                            <IoIosCopy
                                size={17}
                            />

                        </button>

                    );

                },
        },

    ];


    // ==========================================================
    // EXPORTAR EXCEL
    // ==========================================================


    async function exportarExcel() {
        try {
            // 1. CONSULTAR OS DADOS NOVAMENTE
            const resultado = await validarEConsultarRelatorio();

            if (resultado === null) {
                setDadosRelatorio([]);
                setPdfHabilitado(false);
                return;
            }

            // 2. ATUALIZAR A TABELA NA TELA
            setDadosRelatorio(resultado);
            setPdfHabilitado(resultado.length > 0);

            // 3. USAR OS DADOS DA CONSULTA ATUAL
            const dadosParaExportar = resultado;

            if (dadosParaExportar.length === 0) {
                await Swal.fire({
                    icon: "info",
                    title: "Nenhum dado encontrado",
                    text: "Não existem dados para exportar neste período.",
                    background: "#0b1f2d",
                    color: "#fff",
                    confirmButtonText: "Entendi",
                    buttonsStyling: false,
                    customClass: {
                        popup: "produtividade-swal",
                        confirmButton: "produtividade-swal-button"
                    }
                });

                return;
            }

            // ======================================================
            // BIBLIOTECA EXCEL
            // ======================================================

            const XLSX =
                require("xlsx-js-style");


            // ======================================================
            // IDENTIFICAR TIPO
            // ======================================================

            const ehHOExcel =
                tipoProdutividade === "ho_resumo" ||
                tipoProdutividade === "ho_detalhado";


            const ehKMExcel =
                tipoProdutividade === "resumo" ||
                tipoProdutividade === "detalhado";


            const ehResumoExcel =
                tipoProdutividade === "resumo" ||
                tipoProdutividade === "ho_resumo";


            const ehDetalhadoExcel =
                tipoProdutividade === "detalhado" ||
                tipoProdutividade === "ho_detalhado";


            // ======================================================
            // FUNÇÕES AUXILIARES
            // ======================================================

            const numeroSeguro = (valor) => {

                const numero =
                    Number(valor);


                return Number.isFinite(numero)
                    ? numero
                    : 0;

            };


            // ======================================================
            // FORMATAR DATA
            // ======================================================

            const formatarData = (valor) => {

                if (!valor) {

                    return "-";

                }


                const data =
                    new Date(valor);


                if (
                    Number.isNaN(
                        data.getTime()
                    )
                ) {

                    return String(valor);

                }


                return data.toLocaleDateString(
                    "pt-BR",
                    {
                        timeZone:
                            "America/Sao_Paulo"
                    }
                );

            };


            // ======================================================
            // FORMATAR DATA + HORA
            // ======================================================

            const formatarDataHora = (valor) => {

                if (!valor) {

                    return "-";

                }


                const data =
                    new Date(valor);


                if (
                    Number.isNaN(
                        data.getTime()
                    )
                ) {

                    return String(valor);

                }


                return data.toLocaleString(
                    "pt-BR",
                    {

                        timeZone:
                            "America/Sao_Paulo",

                        day:
                            "2-digit",

                        month:
                            "2-digit",

                        year:
                            "numeric",

                        hour:
                            "2-digit",

                        minute:
                            "2-digit"

                    }
                );

            };


            // ======================================================
            // FORMATAR HORAS
            // ======================================================

            const formatarHorasExcel = (valor) => {
                const numero = Number(valor);

                if (!Number.isFinite(numero) || numero < 0) {
                    return "0h 0min";
                }

                // Mantém o total acumulado em horas; não converte para dias.
                const totalMinutos = Math.round(numero * 60);
                const horas = Math.floor(totalMinutos / 60);
                const minutos = totalMinutos % 60;

                return `${horas}h ${minutos}min`;
            };


            // ======================================================
            // TOTAL KM
            // ======================================================

            const kmTotal =
                dadosParaExportar.reduce(

                    (
                        total,
                        item
                    ) => {

                        const km =
                            Number(
                                item.hodometro_total
                            );


                        if (
                            Number.isFinite(km)
                        ) {

                            return (
                                total + km
                            );

                        }


                        return total;

                    },

                    0

                );


            // ======================================================
            // TOTAL DE HORAS
            // ======================================================

            const horasTotal =
                dadosParaExportar.reduce(

                    (
                        total,
                        item
                    ) => {

                        const inicio =
                            Number(
                                item.horimetro_inicial
                            );


                        const fim =
                            Number(
                                item.horimetro_final
                            );


                        if (
                            !Number.isFinite(inicio) ||
                            !Number.isFinite(fim)
                        ) {

                            return total;

                        }


                        const diferenca =
                            fim - inicio;


                        if (
                            diferenca < 0
                        ) {

                            return total;

                        }


                        return (
                            total + diferenca
                        );

                    },

                    0

                );


            // ======================================================
            // NOME DO GRUPO
            // ======================================================

            const grupoNomeExcel =

                grupo?.label ||

                grupo?.nome ||

                dadosParaExportar.find(

                    (item) =>

                        item?.grupo &&
                        String(
                            item.grupo
                        ).trim()

                )?.grupo ||

                "-";


            // ======================================================
            // FILTRO
            // ======================================================

            const filtroExcel =

                grupo

                    ? grupoNomeExcel

                    : placa?.value

                        ? placa.value

                        : "Todos";


            // ======================================================
            // TIPO DO RELATÓRIO
            // ======================================================

            const tipoRelatorioExcel =
                getProdutividadeTipoLabel(
                    tipoProdutividade
                );


            // ======================================================
            // MONTAR DADOS
            //
            // IMPORTANTE:
            //
            // KM:
            // Hodômetro Início
            // Hodômetro Fim
            // Total de KM
            //
            // HO:
            // Horímetro Início
            // Horímetro Fim
            // Total de Horas Trabalhadas
            // ======================================================

            let dadosExcel;


            // ======================================================
            // RESUMO
            // ======================================================

            if (
                ehResumoExcel
            ) {

                dadosExcel =
                    dadosParaExportar.map(

                        (item) => {

                            // ======================================
                            // HORÍMETRO
                            // ======================================

                            const inicio =
                                Number(
                                    item.horimetro_inicial
                                );


                            const fim =
                                Number(
                                    item.horimetro_final
                                );


                            const horas =

                                Number.isFinite(inicio) &&
                                    Number.isFinite(fim) &&
                                    fim >= inicio

                                    ? fim - inicio

                                    : 0;


                            // ======================================
                            // DADOS BASE
                            // ======================================

                            const dadosBase = {

                                "Placa":
                                    item.placa || "-",

                                "Descrição":
                                    item.nome || "-",

                                "Grupo":
                                    item.grupo ||
                                    grupoNomeExcel ||
                                    "-",

                                "Início":
                                    formatarDataHora(
                                        item.data_hora_inicial
                                    ),

                                "Fim":
                                    formatarDataHora(
                                        item.data_hora_final
                                    )

                            };


                            // ======================================
                            // BLOCO KM
                            // ======================================

                            if (
                                ehKMExcel
                            ) {

                                return {

                                    ...dadosBase,

                                    "Hodômetro Início":
                                        numeroSeguro(
                                            item.hodometro_inicial
                                        ),

                                    "Hodômetro Fim":
                                        numeroSeguro(
                                            item.hodometro_final
                                        ),

                                    "Total de KM":
                                        numeroSeguro(
                                            item.hodometro_total
                                        ),

                                    "Endereço Inicial":
                                        item.endereco_inicial ||
                                        "-",

                                    "Endereço Final":
                                        item.endereco_final ||
                                        "-"

                                };

                            }


                            // ======================================
                            // BLOCO HO
                            // ======================================

                            return {

                                ...dadosBase,

                                "Horímetro Início":
                                    Number.isFinite(
                                        inicio
                                    )
                                        ? inicio
                                        : 0,

                                "Horímetro Fim":
                                    Number.isFinite(
                                        fim
                                    )
                                        ? fim
                                        : 0,

                                "Total de Horas Trabalhadas":
                                    formatarHorasExcel(
                                        horas
                                    ),

                                "Endereço Inicial":
                                    item.endereco_inicial ||
                                    "-",

                                "Endereço Final":
                                    item.endereco_final ||
                                    "-"

                            };

                        }

                    );

            }


            // ======================================================
            // DETALHADO
            // ======================================================

            else {

                dadosExcel =
                    dadosParaExportar.map(

                        (item) => {

                            // ======================================
                            // HORÍMETRO
                            // ======================================

                            const inicio =
                                Number(
                                    item.horimetro_inicial
                                );


                            const fim =
                                Number(
                                    item.horimetro_final
                                );


                            const horas =

                                Number.isFinite(inicio) &&
                                    Number.isFinite(fim) &&
                                    fim >= inicio

                                    ? fim - inicio

                                    : 0;


                            // ======================================
                            // DADOS BASE
                            // ======================================

                            const dadosBase = {

                                "Data":
                                    formatarData(
                                        item.datas_filtro
                                    ),

                                "Placa":
                                    item.placa || "-",

                                "Descrição":
                                    item.nome || "-",

                                "Grupo":
                                    item.grupo ||
                                    grupoNomeExcel ||
                                    "-",

                                "Início":
                                    formatarDataHora(
                                        item.data_hora_inicial
                                    ),

                                "Fim":
                                    formatarDataHora(
                                        item.data_hora_final
                                    )

                            };


                            // ======================================
                            // BLOCO KM
                            // ======================================

                            if (
                                ehKMExcel
                            ) {

                                return {

                                    ...dadosBase,

                                    "Hodômetro Início":
                                        numeroSeguro(
                                            item.hodometro_inicial
                                        ),

                                    "Hodômetro Fim":
                                        numeroSeguro(
                                            item.hodometro_final
                                        ),

                                    "Total de KM":
                                        numeroSeguro(
                                            item.hodometro_total
                                        ),

                                    "Endereço Inicial":
                                        item.endereco_inicial ||
                                        "-",

                                    "Endereço Final":
                                        item.endereco_final ||
                                        "-"

                                };

                            }


                            // ======================================
                            // BLOCO HO
                            // ======================================

                            return {

                                ...dadosBase,

                                "Horímetro Início":
                                    Number.isFinite(
                                        inicio
                                    )
                                        ? inicio
                                        : 0,

                                "Horímetro Fim":
                                    Number.isFinite(
                                        fim
                                    )
                                        ? fim
                                        : 0,

                                "Total de Horas Trabalhadas":
                                    formatarHorasExcel(
                                        horas
                                    ),

                                "Endereço Inicial":
                                    item.endereco_inicial ||
                                    "-",

                                "Endereço Final":
                                    item.endereco_final ||
                                    "-"

                            };

                        }

                    );

            }


            // ======================================================
            // CRIAR WORKSHEET
            // ======================================================

            const worksheet =
                XLSX.utils.aoa_to_sheet([]);


            // ======================================================
            // TÍTULO
            // ======================================================

            XLSX.utils.sheet_add_aoa(

                worksheet,

                [
                    [
                        "RELATÓRIO DE PRODUTIVIDADE"
                    ]
                ],

                {
                    origin:
                        "A1"
                }

            );


            // ======================================================
            // SUBTÍTULO
            // ======================================================

            XLSX.utils.sheet_add_aoa(

                worksheet,

                [
                    [
                        "Gestão de produtividade e utilização da frota"
                    ]
                ],

                {
                    origin:
                        "A2"
                }

            );


            // ======================================================
            // INFORMAÇÕES
            // ======================================================

            XLSX.utils.sheet_add_aoa(

                worksheet,

                [
                    [

                        "FILTRO",

                        filtroExcel,

                        "",

                        "PERÍODO",

                        `${formatarData(de)} até ${formatarData(ate)}`,

                        "",

                        "RELATÓRIO",

                        tipoRelatorioExcel

                    ]
                ],

                {
                    origin:
                        "A4"
                }

            );


            // ======================================================
            // RESUMO SUPERIOR
            //
            // KM:
            // REGISTROS | KM TOTAL
            //
            // HO:
            // REGISTROS | HORAS TRABALHADAS
            // ======================================================

            if (
                ehKMExcel
            ) {

                XLSX.utils.sheet_add_aoa(

                    worksheet,

                    [
                        [

                            "REGISTROS",

                            dadosParaExportar.length,

                            "",

                            "KM TOTAL",

                            kmTotal,

                            "",

                            "",

                            ""

                        ]
                    ],

                    {
                        origin:
                            "A5"
                    }

                );

            }

            else {

                XLSX.utils.sheet_add_aoa(

                    worksheet,

                    [
                        [

                            "REGISTROS",

                            dadosParaExportar.length,

                            "",

                            "HORAS TRABALHADAS",

                            formatarHorasExcel(
                                horasTotal
                            ),

                            "",

                            "",

                            ""

                        ]
                    ],

                    {
                        origin:
                            "A5"
                    }

                );

            }


            // ======================================================
            // LINHA VAZIA
            // ======================================================

            XLSX.utils.sheet_add_aoa(

                worksheet,

                [
                    []
                ],

                {
                    origin:
                        "A6"
                }

            );


            // ======================================================
            // TABELA
            // ======================================================

            XLSX.utils.sheet_add_json(

                worksheet,

                dadosExcel,

                {
                    origin:
                        "A7",

                    skipHeader:
                        false

                }

            );


            // ======================================================
            // QUANTIDADE DE COLUNAS
            // ======================================================

            const quantidadeColunas =

                ehResumoExcel

                    ? 11

                    : 12;


            const ultimaColuna =
                quantidadeColunas - 1;


            // ======================================================
            // MERGES
            // ======================================================

            worksheet["!merges"] = [

                {

                    s: {
                        r: 0,
                        c: 0
                    },

                    e: {
                        r: 0,
                        c: ultimaColuna
                    }

                },

                {

                    s: {
                        r: 1,
                        c: 0
                    },

                    e: {
                        r: 1,
                        c: ultimaColuna
                    }

                }

            ];


            // ======================================================
            // CORES
            // ======================================================

            const CORES = {

                preto:
                    "FF404040",

                pretoSuave:
                    "FF303030",

                titulo:
                    "FFF2F2F2",

                azul:
                    "FF0879B5",

                azulEscuro:
                    "FF0B2940",

                azulClaro:
                    "FFEAF4F9",

                azulMuitoClaro:
                    "FFF5FAFC",

                branco:
                    "FFFFFFFF",

                texto:
                    "FF17354B",

                textoSecundario:
                    "FF607789",

                borda:
                    "FFD5E2E9",

                bordaEscura:
                    "FFB8CBD7",

                fundo:
                    "FFFFFFFF"

            };


            // ======================================================
            // APLICAR ESTILO CELULA
            // ======================================================

            const aplicarEstiloCelula = (

                endereco,

                estilo

            ) => {

                if (
                    !worksheet[endereco]
                ) {

                    worksheet[endereco] = {
                        v: ""
                    };

                }


                worksheet[endereco].s =
                    estilo;

            };


            // ======================================================
            // TÍTULO
            // ======================================================

            worksheet["A1"].s = {

                font: {

                    name:
                        "Arial",

                    sz:
                        17,

                    bold:
                        true,

                    color:
                        CORES.titulo

                },

                fill: {

                    fgColor: {

                        rgb:
                            CORES.preto

                    }

                },

                alignment: {

                    horizontal:
                        "left",

                    vertical:
                        "center"

                }

            };


            // ======================================================
            // SUBTÍTULO
            // ======================================================

            worksheet["A2"].s = {

                font: {

                    name:
                        "Arial",

                    sz:
                        9,

                    color:
                        "FFD9E3E9"

                },

                fill: {

                    fgColor: {

                        rgb:
                            CORES.preto

                    }

                },

                alignment: {

                    horizontal:
                        "left",

                    vertical:
                        "center"

                }

            };


            // ======================================================
            // ALTURA DAS LINHAS
            // ======================================================

            worksheet["!rows"] = [];


            worksheet["!rows"][0] = {
                hpt: 30
            };


            worksheet["!rows"][1] = {
                hpt: 20
            };


            worksheet["!rows"][2] = {
                hpt: 10
            };


            worksheet["!rows"][3] = {
                hpt: 25
            };


            worksheet["!rows"][4] = {
                hpt: 32
            };


            worksheet["!rows"][5] = {
                hpt: 10
            };


            worksheet["!rows"][6] = {
                hpt: 30
            };


            // ======================================================
            // ESTILO LABEL
            // ======================================================

            const estiloLabel = {

                font: {

                    name:
                        "Arial",

                    sz:
                        8,

                    bold:
                        true,

                    color:
                        CORES.texto

                },

                fill: {

                    fgColor: {

                        rgb:
                            CORES.azulClaro

                    }

                },

                alignment: {

                    horizontal:
                        "center",

                    vertical:
                        "center",

                    wrapText:
                        true

                },

                border: {

                    top: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    },

                    bottom: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    },

                    left: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    },

                    right: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    }

                }

            };


            // ======================================================
            // ESTILO VALOR
            // ======================================================

            const estiloValor = {

                font: {

                    name:
                        "Arial",

                    sz:
                        9,

                    bold:
                        true,

                    color:
                        CORES.texto

                },

                fill: {

                    fgColor: {

                        rgb:
                            CORES.fundo

                    }

                },

                alignment: {

                    horizontal:
                        "center",

                    vertical:
                        "center"

                },

                border: {

                    top: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    },

                    bottom: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    },

                    left: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    },

                    right: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.borda

                        }

                    }

                }

            };


            // ======================================================
            // LABELS
            // ======================================================

            [

                "A4",
                "D4",
                "G4",

                "A5",
                "D5"

            ].forEach(

                (celula) => {

                    aplicarEstiloCelula(
                        celula,
                        estiloLabel
                    );

                }

            );


            // ======================================================
            // VALORES
            // ======================================================

            [

                "B4",
                "E4",
                "H4"

            ].forEach(

                (celula) => {

                    aplicarEstiloCelula(
                        celula,
                        estiloValor
                    );

                }

            );


            // ======================================================
            // VALORES DO RESUMO
            // ======================================================

            [

                "B5",
                "E5"

            ].forEach(

                (celula) => {

                    aplicarEstiloCelula(

                        celula,

                        {

                            font: {

                                name:
                                    "Arial",

                                sz:
                                    13,

                                bold:
                                    true,

                                color:
                                    CORES.azul

                            },

                            fill: {

                                fgColor: {

                                    rgb:
                                        CORES.azulMuitoClaro

                                }

                            },

                            alignment: {

                                horizontal:
                                    "center",

                                vertical:
                                    "center",

                                wrapText:
                                    true

                            },

                            border: {

                                top: {

                                    style:
                                        "thin",

                                    color: {

                                        rgb:
                                            CORES.borda

                                    }

                                },

                                bottom: {

                                    style:
                                        "thin",

                                    color: {

                                        rgb:
                                            CORES.borda

                                    }

                                },

                                left: {

                                    style:
                                        "thin",

                                    color: {

                                        rgb:
                                            CORES.borda

                                    }

                                },

                                right: {

                                    style:
                                        "thin",

                                    color: {

                                        rgb:
                                            CORES.borda

                                    }

                                }

                            }

                        }

                    );

                }

            );


            // ======================================================
            // FORMATAÇÃO DO TOTAL
            // ======================================================

            if (
                ehKMExcel &&
                worksheet["E5"]
            ) {

                worksheet["E5"].z =
                    "#,##0.00";

            }


            // ======================================================
            // RANGE
            // ======================================================

            const range =
                XLSX.utils.decode_range(
                    worksheet["!ref"]
                );


            const headerRow =
                6;


            const primeiraLinha =
                7;


            const ultimaLinha =
                range.e.r;


            // ======================================================
            // ESTILO CABEÇALHO
            // ======================================================

            const estiloCabecalho = {

                font: {

                    name:
                        "Arial",

                    sz:
                        9,

                    bold:
                        true,

                    color:
                        CORES.branco

                },

                fill: {

                    fgColor: {

                        rgb:
                            CORES.azul

                    }

                },

                alignment: {

                    horizontal:
                        "center",

                    vertical:
                        "center",

                    wrapText:
                        true

                },

                border: {

                    top: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.azulEscuro

                        }

                    },

                    bottom: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.azulEscuro

                        }

                    },

                    left: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.azulEscuro

                        }

                    },

                    right: {

                        style:
                            "thin",

                        color: {

                            rgb:
                                CORES.azulEscuro

                        }

                    }

                }

            };


            // ======================================================
            // APLICAR CABEÇALHO
            // ======================================================

            for (

                let col = 0;

                col <= range.e.c;

                col++

            ) {

                const endereco =
                    XLSX.utils.encode_cell({

                        r:
                            headerRow,

                        c:
                            col

                    });


                aplicarEstiloCelula(

                    endereco,

                    estiloCabecalho

                );

            }


            // ======================================================
            // ESTILO DAS LINHAS
            // ======================================================

            for (

                let row =
                    primeiraLinha;

                row <=
                ultimaLinha;

                row++

            ) {

                const linhaPar =

                    (
                        row -
                        primeiraLinha
                    ) % 2 === 0;


                for (

                    let col = 0;

                    col <= range.e.c;

                    col++

                ) {

                    const endereco =
                        XLSX.utils.encode_cell({

                            r:
                                row,

                            c:
                                col

                        });


                    if (
                        !worksheet[endereco]
                    ) {

                        continue;

                    }


                    worksheet[endereco].s = {

                        font: {

                            name:
                                "Arial",

                            sz:
                                9,

                            color:
                                CORES.texto

                        },

                        fill: {

                            fgColor: {

                                rgb:

                                    linhaPar

                                        ? CORES.fundo

                                        : CORES.azulMuitoClaro

                            }

                        },

                        alignment: {

                            horizontal:
                                "center",

                            vertical:
                                "center",

                            wrapText:
                                false

                        },

                        border: {

                            bottom: {

                                style:
                                    "thin",

                                color: {

                                    rgb:
                                        CORES.borda

                                }

                            }

                        }

                    };

                }

            }


            // ======================================================
            // IDENTIFICAR COLUNAS
            // ======================================================

            const cabecalhos =

                dadosExcel.length > 0

                    ? Object.keys(
                        dadosExcel[0]
                    )

                    : [];


            const indiceData =
                cabecalhos.indexOf(
                    "Data"
                );


            const indicePlaca =
                cabecalhos.indexOf(
                    "Placa"
                );


            const indiceInicio =
                cabecalhos.indexOf(
                    "Início"
                );


            const indiceFim =
                cabecalhos.indexOf(
                    "Fim"
                );


            const indiceHodometroInicial =
                cabecalhos.indexOf(
                    "Hodômetro Início"
                );


            const indiceHodometroFinal =
                cabecalhos.indexOf(
                    "Hodômetro Fim"
                );


            const indiceTotalKm =
                cabecalhos.indexOf(
                    "Total de KM"
                );


            const indiceHorimetroInicial =
                cabecalhos.indexOf(
                    "Horímetro Início"
                );


            const indiceHorimetroFinal =
                cabecalhos.indexOf(
                    "Horímetro Fim"
                );


            const indiceTotalHoras =
                cabecalhos.indexOf(
                    "Total de Horas Trabalhadas"
                );


            const indiceEnderecoInicial =
                cabecalhos.indexOf(
                    "Endereço Inicial"
                );


            const indiceEnderecoFinal =
                cabecalhos.indexOf(
                    "Endereço Final"
                );


            // ======================================================
            // COLUNAS CENTRALIZADAS
            // ======================================================

            const colunasCentralizadas = [

                indiceData,

                indicePlaca,

                indiceInicio,

                indiceFim,

                indiceHodometroInicial,

                indiceHodometroFinal,

                indiceTotalKm,

                indiceHorimetroInicial,

                indiceHorimetroFinal,

                indiceTotalHoras

            ];


            colunasCentralizadas.forEach(

                (indice) => {

                    if (
                        indice < 0
                    ) {

                        return;

                    }


                    for (

                        let row =
                            primeiraLinha;

                        row <=
                        ultimaLinha;

                        row++

                    ) {

                        const endereco =
                            XLSX.utils.encode_cell({

                                r:
                                    row,

                                c:
                                    indice

                            });


                        if (
                            !worksheet[endereco]
                        ) {

                            continue;

                        }


                        worksheet[endereco].s = {

                            ...worksheet[
                                endereco
                            ].s,

                            alignment: {

                                horizontal:
                                    "center",

                                vertical:
                                    "center",

                                wrapText:
                                    false

                            }

                        };

                    }

                }

            );


            // ======================================================
            // ENDEREÇOS
            //
            // Deixa os endereços alinhados à esquerda
            // e permite quebra de texto no Excel.
            // ======================================================

            [

                indiceEnderecoInicial,

                indiceEnderecoFinal

            ].forEach(

                (indice) => {

                    if (
                        indice < 0
                    ) {

                        return;

                    }


                    for (

                        let row =
                            primeiraLinha;

                        row <=
                        ultimaLinha;

                        row++

                    ) {

                        const endereco =
                            XLSX.utils.encode_cell({

                                r:
                                    row,

                                c:
                                    indice

                            });


                        if (
                            !worksheet[endereco]
                        ) {

                            continue;

                        }


                        worksheet[endereco].s = {

                            ...worksheet[endereco].s,

                            alignment: {

                                horizontal:
                                    "left",

                                vertical:
                                    "center",

                                wrapText:
                                    true

                            }

                        };

                    }

                }

            );


            // ======================================================
            // FORMATAR HODÔMETRO
            // ======================================================

            [

                indiceHodometroInicial,

                indiceHodometroFinal,

                indiceTotalKm

            ].forEach(

                (indice) => {

                    if (
                        indice < 0
                    ) {

                        return;

                    }


                    for (

                        let row =
                            primeiraLinha;

                        row <=
                        ultimaLinha;

                        row++

                    ) {

                        const endereco =
                            XLSX.utils.encode_cell({

                                r:
                                    row,

                                c:
                                    indice

                            });


                        if (
                            !worksheet[endereco]
                        ) {

                            continue;

                        }


                        worksheet[endereco].z =
                            "#,##0.00";


                        worksheet[endereco].s = {

                            ...worksheet[endereco].s,

                            alignment: {

                                horizontal:
                                    "right",

                                vertical:
                                    "center"

                            }

                        };

                    }

                }

            );


            // ======================================================
            // FORMATAR HORÍMETRO
            // ======================================================

            [

                indiceHorimetroInicial,

                indiceHorimetroFinal

            ].forEach(

                (indice) => {

                    if (
                        indice < 0
                    ) {

                        return;

                    }


                    for (

                        let row =
                            primeiraLinha;

                        row <=
                        ultimaLinha;

                        row++

                    ) {

                        const endereco =
                            XLSX.utils.encode_cell({

                                r:
                                    row,

                                c:
                                    indice

                            });


                        if (
                            !worksheet[endereco]
                        ) {

                            continue;

                        }


                        worksheet[endereco].z =
                            "0.0";


                        worksheet[endereco].s = {

                            ...worksheet[endereco].s,

                            alignment: {

                                horizontal:
                                    "right",

                                vertical:
                                    "center"

                            }

                        };

                    }

                }

            );


            // ======================================================
            // DESTACAR TOTAL KM
            // ======================================================

            if (
                indiceTotalKm >= 0
            ) {

                for (

                    let row =
                        primeiraLinha;

                    row <=
                    ultimaLinha;

                    row++

                ) {

                    const endereco =
                        XLSX.utils.encode_cell({

                            r:
                                row,

                            c:
                                indiceTotalKm

                        });


                    if (
                        !worksheet[endereco]
                    ) {

                        continue;

                    }


                    worksheet[endereco].s = {

                        ...worksheet[endereco].s,

                        font: {

                            ...worksheet[endereco].s.font,

                            bold:
                                true,

                            color:
                                CORES.azul

                        }

                    };

                }

            }


            // ======================================================
            // DESTACAR TOTAL DE HORAS
            // ======================================================

            if (
                indiceTotalHoras >= 0
            ) {

                for (

                    let row =
                        primeiraLinha;

                    row <=
                    ultimaLinha;

                    row++

                ) {

                    const endereco =
                        XLSX.utils.encode_cell({

                            r:
                                row,

                            c:
                                indiceTotalHoras

                        });


                    if (
                        !worksheet[endereco]
                    ) {

                        continue;

                    }


                    worksheet[endereco].s = {

                        ...worksheet[endereco].s,

                        font: {

                            ...worksheet[endereco].s.font,

                            bold:
                                true,

                            color:
                                CORES.azul

                        },

                        alignment: {

                            horizontal:
                                "center",

                            vertical:
                                "center"

                        }

                    };

                }

            }


            // ======================================================
            // LARGURA DAS COLUNAS
            // ======================================================

            let larguras;


            // ======================================================
            // RESUMO KM
            // ======================================================

            if (
                tipoProdutividade === "resumo"
            ) {

                larguras = [

                    13, // Placa
                    25, // Descrição
                    22, // Grupo
                    21, // Início
                    21, // Fim
                    19, // Hodômetro Início
                    19, // Hodômetro Fim
                    18, // Total de KM
                    60, // Endereço Inicial
                    60  // Endereço Final

                ];

            }


            // ======================================================
            // RESUMO HO
            // ======================================================

            else if (
                tipoProdutividade === "ho_resumo"
            ) {

                larguras = [

                    13, // Placa
                    25, // Descrição
                    22, // Grupo
                    21, // Início
                    21, // Fim
                    19, // Horímetro Início
                    19, // Horímetro Fim
                    25, // Total de Horas Trabalhadas
                    60, // Endereço Inicial
                    60  // Endereço Final

                ];

            }


            // ======================================================
            // DETALHADO KM
            // ======================================================

            else if (
                tipoProdutividade === "detalhado"
            ) {

                larguras = [

                    13, // Data
                    13, // Placa
                    25, // Descrição
                    22, // Grupo
                    21, // Início
                    21, // Fim
                    19, // Hodômetro Início
                    19, // Hodômetro Fim
                    18, // Total de KM
                    60, // Endereço Inicial
                    60  // Endereço Final

                ];

            }


            // ======================================================
            // DETALHADO HO
            // ======================================================

            else {

                larguras = [

                    13, // Data
                    13, // Placa
                    25, // Descrição
                    22, // Grupo
                    21, // Início
                    21, // Fim
                    19, // Horímetro Início
                    19, // Horímetro Fim
                    25, // Total de Horas Trabalhadas
                    60, // Endereço Inicial
                    60  // Endereço Final

                ];

            }


            worksheet["!cols"] =
                larguras.map(

                    (largura) => ({

                        wch:
                            largura

                    })

                );


            // ======================================================
            // FREEZE
            // ======================================================

            worksheet["!freeze"] = {

                xSplit:
                    0,

                ySplit:
                    7

            };


            // ======================================================
            // AUTOFILTER
            // ======================================================

            worksheet["!autofilter"] = {

                ref:

                    XLSX.utils.encode_range({

                        s: {

                            r:
                                headerRow,

                            c:
                                0

                        },

                        e: {

                            r:
                                ultimaLinha,

                            c:
                                range.e.c

                        }

                    })

            };


            // ======================================================
            // CONFIGURAÇÃO DE IMPRESSÃO
            // ======================================================

            worksheet["!pageSetup"] = {

                orientation:
                    "landscape",

                paperSize:
                    "9",

                fitToWidth:
                    1,

                fitToHeight:
                    0

            };


            // ======================================================
            // MARGENS
            // ======================================================

            worksheet["!margins"] = {

                left:
                    0.25,

                right:
                    0.25,

                top:
                    0.50,

                bottom:
                    0.50,

                header:
                    0.20,

                footer:
                    0.20

            };


            // ======================================================
            // CRIAR WORKBOOK
            // ======================================================

            const workbook =
                XLSX.utils.book_new();


            // ======================================================
            // ADICIONAR ABA
            // ======================================================

            XLSX.utils.book_append_sheet(

                workbook,

                worksheet,

                tipoRelatorioExcel

            );


            // ======================================================
            // PROPRIEDADES
            // ======================================================

            workbook.Props = {

                Title:
                    "Relatório de Produtividade",

                Subject:
                    "Relatório de produtividade da frota",

                Author:
                    "INOVA Rastreamento",

                Company:
                    "INOVA Rastreamento",

                Category:
                    "Produtividade",

                Keywords:
                    "produtividade, frota, km, horímetro"

            };


            // ======================================================
            // IDENTIFICADOR
            // ======================================================

            let identificador =
                "todos";


            if (
                grupo
            ) {

                identificador =

                    String(
                        grupoNomeExcel
                    )

                        .replace(
                            /[^a-zA-Z0-9À-ÿ]+/g,
                            "_"
                        )

                        .replace(
                            /^_+|_+$/g,
                            ""
                        ) ||

                    "grupo";

            }


            else if (
                placa?.value
            ) {

                identificador =

                    String(
                        placa.value
                    )

                        .replace(
                            /[^a-zA-Z0-9-]+/g,
                            "_"
                        );

            }


            // ======================================================
            // NOME DO ARQUIVO
            // ======================================================

            const tipoArquivo =

                getProdutividadeTipoLabel(
                    tipoProdutividade
                )

                    .replace(
                        /\s+/g,
                        "_"
                    );


            const nomeArquivo =

                `Relatorio_Produtividade_${tipoArquivo}_${identificador}.xlsx`;


            // ======================================================
            // GERAR EXCEL
            // ======================================================

            XLSX.writeFile(

                workbook,

                nomeArquivo

            );


        }


        // ==========================================================
        // ERRO
        // ==========================================================

        catch (error) {

            console.error(
                "Erro Excel:",
                error
            );


            await Swal.fire({

                icon:
                    "error",

                title:
                    "Erro ao gerar Excel",

                text:
                    "Não foi possível gerar o arquivo Excel.",

                background:
                    "#0b1f2d",

                color:
                    "#fff",

                confirmButtonText:
                    "Entendi",

                buttonsStyling:
                    false,

                customClass: {

                    popup:
                        "produtividade-swal",

                    confirmButton:
                        "produtividade-swal-button"

                }

            });

        }

    }




    // ==========================================================
    // PDF
    // ==========================================================


    async function gerarPDF() {


        // ==========================================================
        // CONSULTAR DADOS ATUALIZADOS
        // ==========================================================

        const consulta = await validarEConsultarRelatorio();

        if (consulta === null || !Array.isArray(consulta)) {
            setDadosRelatorio([]);
            setPdfHabilitado(false);
            return;
        }

        // ==========================================================
        // ATUALIZAR A TABELA NA TELA
        // ==========================================================

        setDadosRelatorio(consulta);
        setPdfHabilitado(consulta.length > 0);

        // Usar o resultado diretamente, sem depender da atualização
        // assíncrona do estado React.
        const dadosPDF = consulta;

        if (dadosPDF.length === 0) {
            await Swal.fire({
                icon: "warning",
                title: "Nenhum registro",
                text: "Não há dados para gerar o PDF.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Entendi",
                buttonsStyling: false,
                customClass: {
                    popup: "produtividade-swal",
                    icon: "produtividade-swal-icon",
                    title: "produtividade-swal-title",
                    htmlContainer: "produtividade-swal-text",
                    confirmButton: "produtividade-swal-button"
                }
            });

            return;
        }

        // ==========================================================
        // IDENTIFICAR TIPO E CALCULAR TOTAIS DA CONSULTA ATUAL
        // ==========================================================

        const ehHO =
            tipoProdutividade === "ho_resumo" ||
            tipoProdutividade === "ho_detalhado";

        const kmTotal = dadosPDF.reduce((total, item) => {
            const km = Number(item.hodometro_total);

            return total + (
                Number.isFinite(km) ? km : 0
            );
        }, 0);

        const horasTotal = dadosPDF.reduce((total, item) => {
            const inicio = Number(item.horimetro_inicial);
            const fim = Number(item.horimetro_final);

            if (
                !Number.isFinite(inicio) ||
                !Number.isFinite(fim) ||
                fim < inicio
            ) {
                return total;
            }

            return total + (fim - inicio);
        }, 0);

        const tipoNome =
            produtividadeTipoOptions.find(
                (item) => item.value === tipoProdutividade
            )?.label || "-";

        console.log("=================================");
        console.log("[PRODUTIVIDADE] GERAÇÃO DE PDF");
        console.log("Tipo:", tipoProdutividade);
        console.log("Placa:", placa?.value || null);
        console.log("Grupo:", grupo?.value || null);
        console.log("Grupo nome:", grupo?.label || grupo?.nome || null);
        console.log("Quantidade:", dadosPDF.length);
        console.log("Dados:", dadosPDF);
        console.log("KM total:", kmTotal);
        console.log("Horas total:", horasTotal);
        console.log("=================================");






        // ==========================================================
        // TOKEN
        // ==========================================================

        const token =
            localStorage.getItem("id");

        if (!token) {
            await Swal.fire({
                icon: "error",
                title: "Cliente não identificado",
                text: "Não foi possível identificar o cliente.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Entendi",
                buttonsStyling: false,
                customClass: {
                    popup: "produtividade-swal",
                    icon: "produtividade-swal-icon",
                    title: "produtividade-swal-title",
                    htmlContainer: "produtividade-swal-text",
                    confirmButton: "produtividade-swal-button",
                },
            });

            return;
        }

        // ==========================================================
        // ABRIR NOVA ABA
        // ==========================================================

        const novaAba = window.open(
            "",
            "_blank"
        );

        if (!novaAba) {
            await Swal.fire({
                icon: "warning",
                title: "Nova aba bloqueada",
                text: "Permita pop-ups para visualizar o relatório.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Entendi",
                buttonsStyling: false,
                customClass: {
                    popup: "produtividade-swal",
                    icon: "produtividade-swal-icon",
                    title: "produtividade-swal-title",
                    htmlContainer: "produtividade-swal-text",
                    confirmButton: "produtividade-swal-button",
                },
            });

            return;
        }

        // ==========================================================
        // LOADING NA NOVA ABA
        // ==========================================================

        novaAba.document.write(`
        <!DOCTYPE html>

        <html lang="pt-BR">

        <head>

            <meta charset="UTF-8">

            <title>
                Gerando relatório...
            </title>

            <style>

                * {
                    box-sizing: border-box;
                }

                html,
                body {

                    margin: 0;

                    width: 100%;
                    height: 100%;

                    font-family:
                        Arial,
                        Helvetica,
                        sans-serif;

                    background: #0b1220;
                }

                body {

                    display: flex;

                    align-items: center;

                    justify-content: center;
                }

                .produtividade-loading-container {

                    width: 380px;

                    padding: 42px 35px;

                    text-align: center;

                    border-radius: 18px;

                    background:
                        linear-gradient(
                            145deg,
                            #111c2d,
                            #0d1726
                        );

                    border:
                        1px solid
                        rgba(255,255,255,.08);

                    box-shadow:
                        0 25px 70px
                        rgba(0,0,0,.45);
                }

                .produtividade-loading-spinner {

                    width: 48px;
                    height: 48px;

                    margin:
                        0 auto 25px;

                    border-radius: 50%;

                    border:
                        3px solid
                        rgba(255,255,255,.10);

                    border-top-color:
                        #0b73b5;

                    animation:
                        produtividadeSpin
                        .8s linear infinite;
                }

                @keyframes produtividadeSpin {

                    to {
                        transform:
                            rotate(360deg);
                    }

                }

                .produtividade-loading-title {

                    font-size: 20px;

                    font-weight: 700;

                    color: #ffffff;

                    margin-bottom: 8px;
                }

                .produtividade-loading-text {

                    font-size: 13px;

                    color: #94a3b8;

                    line-height: 1.5;
                }

                .produtividade-loading-brand {

                    margin-top: 25px;

                    font-size: 10px;

                    color: #4d87ad;

                    letter-spacing: 1.2px;

                    text-transform: uppercase;
                }

            </style>

        </head>

        <body>

            <div
                class="produtividade-loading-container"
            >

                <div
                    class="produtividade-loading-spinner"
                ></div>

                <div
                    class="produtividade-loading-title"
                >
                    Gerando relatório
                </div>

                <div
                    class="produtividade-loading-text"
                >
                    Estamos preparando seu PDF.<br>
                    Isso pode levar alguns segundos...
                </div>

                <div
                    class="produtividade-loading-brand"
                >
                    Relatório de Produtividade
                </div>

            </div>

        </body>

        </html>
    `);

        novaAba.document.close();

        // ==========================================================
        // FORM POST
        // ==========================================================

        const form =
            novaAba.document.createElement("form");

        form.method = "POST";

        form.action =
            `${api.defaults.baseURL}/produtividade/pdf`;

        form.style.display = "none";

        // ==========================================================
        // TOKEN
        // ==========================================================

        const inputToken =
            novaAba.document.createElement("input");

        inputToken.type = "hidden";

        inputToken.name = "token";

        inputToken.value = token;

        form.appendChild(inputToken);

        // ==========================================================
        // TIPO
        // ==========================================================

        const inputTipo =
            novaAba.document.createElement("input");

        inputTipo.type = "hidden";

        inputTipo.name = "tipo";

        inputTipo.value =
            tipoProdutividade || "resumo";

        form.appendChild(inputTipo);


        // ==========================================================
        // NOME DO TIPO
        // ==========================================================

        const inputTipoNome =
            novaAba.document.createElement("input");

        inputTipoNome.type = "hidden";

        inputTipoNome.name = "tipoNome";

        inputTipoNome.value =
            tipoNome;

        form.appendChild(inputTipoNome);








        // ==========================================================
        // PLACA
        // ==========================================================

        const inputPlaca =
            novaAba.document.createElement("input");

        inputPlaca.type = "hidden";

        inputPlaca.name = "placa";

        inputPlaca.value =
            placa?.value || "";

        form.appendChild(inputPlaca);

        // ==========================================================
        // GRUPO
        // ==========================================================

        const inputGrupo =
            novaAba.document.createElement("input");

        inputGrupo.type = "hidden";

        inputGrupo.name = "grupo";

        inputGrupo.value =
            grupo?.value || "";

        form.appendChild(inputGrupo);

        // ==========================================================
        // NOME DO GRUPO
        // ==========================================================

        const inputGrupoNome =
            novaAba.document.createElement("input");

        inputGrupoNome.type = "hidden";

        inputGrupoNome.name = "grupoNome";

        inputGrupoNome.value =
            grupo?.label ||
            grupo?.nome ||
            "";

        form.appendChild(inputGrupoNome);

        // ==========================================================
        // DATA INICIAL
        // ==========================================================

        const inputDe =
            novaAba.document.createElement("input");

        inputDe.type = "hidden";

        inputDe.name = "de";

        inputDe.value = de || "";

        form.appendChild(inputDe);

        // ==========================================================
        // DATA FINAL
        // ==========================================================

        const inputAte =
            novaAba.document.createElement("input");

        inputAte.type = "hidden";

        inputAte.name = "ate";

        inputAte.value = ate || "";

        form.appendChild(inputAte);

        // ==========================================================
        // HORA INICIAL
        // ==========================================================

        const inputHoraDe =
            novaAba.document.createElement("input");

        inputHoraDe.type = "hidden";

        inputHoraDe.name = "horaDe";

        inputHoraDe.value =
            horaDe || "00:00";

        form.appendChild(inputHoraDe);

        // ==========================================================
        // HORA FINAL
        // ==========================================================

        const inputHoraAte =
            novaAba.document.createElement("input");

        inputHoraAte.type = "hidden";

        inputHoraAte.name = "horaAte";

        inputHoraAte.value =
            horaAte || "23:59";

        form.appendChild(inputHoraAte);

        // ==========================================================
        // CLIENTE
        // ==========================================================

        const inputCliente =
            novaAba.document.createElement("input");

        inputCliente.type = "hidden";

        inputCliente.name = "clienteNome";

        inputCliente.value =
            clienteNome || "";

        form.appendChild(inputCliente);

        // ==========================================================
        // KM TOTAL
        // ==========================================================

        const inputKm =
            novaAba.document.createElement("input");

        inputKm.type = "hidden";

        inputKm.name = "kmTotal";

        inputKm.value =
            String(kmTotal || 0);

        form.appendChild(inputKm);

        // ==========================================================
        // HORAS TOTAL
        // ==========================================================

        const inputHoras =
            novaAba.document.createElement("input");

        inputHoras.type = "hidden";

        inputHoras.name = "horasTotal";

        inputHoras.value =
            String(horasTotal || 0);

        form.appendChild(inputHoras);

        // ==========================================================
        // DADOS DO RELATÓRIO
        //
        // IMPORTANTE:
        // O backend usa JSON.parse(req.body.dados)
        // ==========================================================

        const inputDados =
            novaAba.document.createElement("input");

        inputDados.type = "hidden";

        inputDados.name = "dados";

        inputDados.value =
            JSON.stringify(dadosPDF);

        form.appendChild(inputDados);

        // ==========================================================
        // DEBUG
        // ==========================================================

        console.log("=================================");
        console.log(
            "[PRODUTIVIDADE] POST /produtividade/pdf"
        );
        console.log("Token:", token);
        console.log("Tipo:", tipoProdutividade);
        console.log("Placa:", placa?.value || null);
        console.log("Grupo:", grupo?.value || null);
        console.log(
            "Grupo nome:",
            grupo?.label || grupo?.nome || null
        );
        console.log("De:", de);
        console.log("Até:", ate);
        console.log("Hora de:", horaDe);
        console.log("Hora até:", horaAte);
        console.log("Quantidade:", dadosPDF.length);
        console.log("Dados:", dadosPDF);
        console.log("=================================");

        // ==========================================================
        // ADICIONAR FORM NA NOVA ABA
        // ==========================================================

        novaAba.document.body.appendChild(form);

        // ==========================================================
        // ENVIAR
        // ==========================================================

        form.submit();
    }

    // ==========================================================
    // THEME MUI
    // ==========================================================

    const theme =
        createTheme({

            palette: {

                mode:
                    "dark",

                background: {

                    default:
                        "#081722",

                    paper:
                        "#0b1e2d",

                },

                text: {

                    primary:
                        "#ffffff",

                    secondary:
                        "#cbd5e1",

                },

            },


            components: {

                MuiDataGrid: {

                    styleOverrides: {

                        root: {

                            border:
                                "none",

                            background:
                                "#0b1e2d",

                            color:
                                "#fff",

                        },


                        columnHeaders: {

                            background:
                                "#12384d",

                            color:
                                "#fff",

                            borderBottom:
                                "1px solid #1e4f63",

                        },


                        cell: {

                            borderBottom:
                                "1px solid #17394a",

                        },


                        footerContainer: {

                            background:
                                "#12384d",

                            borderTop:
                                "1px solid #1e4f63",

                        },

                    },

                },

            },

        });







    // ==========================================================
    // COLUNAS ATUAIS
    // ==========================================================

    const columns =
        tipoProdutividade ===
            "resumo"

            ? columnsResumo

            : columnsDetalhado;


    // ==========================================================
    // RENDER
    // ==========================================================




    const horasTotal = dadosRelatorio.reduce((total, item) => {
        const inicio = Number(item.horimetro_inicial);
        const fim = Number(item.horimetro_final);

        if (!Number.isFinite(inicio) || !Number.isFinite(fim)) {
            return total;
        }

        const diferenca = fim - inicio;

        if (diferenca < 0) {
            return total;
        }

        return total + diferenca;
    }, 0);



    function formatarHoras(horas) {
        if (!Number.isFinite(horas) || horas < 0) {
            return "0h 0min";
        }

        const totalMinutos = Math.round(horas * 60);

        const dias = Math.floor(totalMinutos / (24 * 60));

        const minutosRestantes = totalMinutos % (24 * 60);

        const horasRestantes = Math.floor(minutosRestantes / 60);

        const minutos = minutosRestantes % 60;



        // Menos de 24 horas
        return `${horasRestantes}h ${minutos}min`;
    }



    /**
     * Soma meses a uma data sem estourar o último dia do mês.
     * Exemplo: 31/01 + 2 meses = 31/03.
     */
    const adicionarMeses = (data, quantidade) => {
        const resultado = new Date(data);
        const diaOriginal = resultado.getDate();

        resultado.setDate(1);
        resultado.setMonth(resultado.getMonth() + quantidade);

        const ultimoDia = new Date(
            resultado.getFullYear(),
            resultado.getMonth() + 1,
            0
        ).getDate();

        resultado.setDate(Math.min(diaOriginal, ultimoDia));

        return resultado;
    };

    /**
     * Converte YYYY-MM-DD em uma data local,
     * evitando problemas de fuso horário.
     */
    const converterDataLocal = (data) => {
        if (!data) return null;

        const [ano, mes, dia] = data.split("-").map(Number);

        return new Date(ano, mes - 1, dia);
    };

    /**
     * Exibe o alerta de período máximo.
     */
    const alertarPeriodoMaximo = async () => {
        await Swal.fire({
            icon: "warning",
            title: "Período máximo excedido",
            text: "O relatório permite consultar no máximo 2 meses por vez.",
            background: "#0b1f2d",
            color: "#fff",
            confirmButtonText: "Entendi",
            buttonsStyling: false,
            customClass: {
                popup: "produtividade-swal",
                icon: "produtividade-swal-icon",
                title: "produtividade-swal-title",
                htmlContainer: "produtividade-swal-text",
                confirmButton: "produtividade-swal-button",
            },
        });
    };



    const validarPeriodoRelatorio = async () => {
        if (!de || !ate) {
            await Swal.fire({
                icon: "warning",
                title: "Período obrigatório",
                text: "Selecione a data inicial e a data final.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Entendi",
                buttonsStyling: false,
                customClass: {
                    popup: "produtividade-swal",
                    icon: "produtividade-swal-icon",
                    title: "produtividade-swal-title",
                    htmlContainer: "produtividade-swal-text",
                    confirmButton: "produtividade-swal-button",
                },
            });

            return false;
        }

        const dataInicial = converterDataLocal(de);
        const dataFinal = converterDataLocal(ate);

        if (dataFinal < dataInicial) {
            await Swal.fire({
                icon: "warning",
                title: "Período inválido",
                text: "A data final não pode ser anterior à data inicial.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Entendi",
                buttonsStyling: false,
                customClass: {
                    popup: "produtividade-swal",
                    icon: "produtividade-swal-icon",
                    title: "produtividade-swal-title",
                    htmlContainer: "produtividade-swal-text",
                    confirmButton: "produtividade-swal-button",
                },
            });

            return false;
        }

        const limite = adicionarMeses(dataInicial, 2);

        if (dataFinal > limite) {
            await Swal.fire({
                icon: "warning",
                title: "Período máximo excedido",
                text: "O relatório permite consultar no máximo 2 meses por vez. Ajuste as datas para continuar.",
                background: "#0b1f2d",
                color: "#fff",
                confirmButtonText: "Ajustar período",
                buttonsStyling: false,
                customClass: {
                    popup: "produtividade-swal",
                    icon: "produtividade-swal-icon",
                    title: "produtividade-swal-title",
                    htmlContainer: "produtividade-swal-text",
                    confirmButton: "produtividade-swal-button",
                },
            });

            return false;
        }

        return true;
    };






    return (

        <ThemeProvider
            theme={theme}
        >

            <div className="produtividade-container">

                {/* ==================================================
                    CARD PRINCIPAL
                    ================================================== */}

                <nav
                    className="produtividade-card"
                >

                    <div
                        className="produtividade-content"
                    >


                        {/* ==================================================
                            CABEÇALHO
                            ================================================== */}

                        <div
                            className="produtividade-header"
                        >

                            <div
                                className="produtividade-header-content"
                            >

                                <div
                                    className="produtividade-header-icon"
                                >

                                    <TbReportAnalytics
                                        size={18}
                                    />

                                </div>


                                <div>

                                    <span
                                        className="produtividade-overline"
                                    >
                                        INOVA RASTREAMENTO
                                    </span>


                                    <h4
                                        className="produtividade-titulo"
                                    >
                                        Relatório de Produtividade
                                    </h4>

                                </div>

                            </div>

                        </div>


                        {/* ==================================================
                            FORMULÁRIO
                            ================================================== */}

                        <form
                            className="produtividade-form"
                            onSubmit={
                                handleSubmit
                            }
                        >


                            {/* ==================================================
                                01 — RELATÓRIO
                                ================================================== */}

                            <section
                                className="produtividade-section"
                            >

                                <div
                                    className="produtividade-section-header"
                                >

                                    <span
                                        className="produtividade-section-number"
                                    >
                                        01
                                    </span>


                                    <div>

                                        <span
                                            className="produtividade-section-title"
                                        >
                                            Tipo de relatório
                                        </span>

                                        <span
                                            className="produtividade-section-description"
                                        >
                                            Escolha o tipo de cálculo de KM ou HO
                                        </span>

                                    </div>

                                </div>


                                <div
                                    className="row"
                                >

                                    <div
                                        className="col-md-6"
                                    >



                                        <div className="produtividade-tipos-relatorio">

                                            {/* ==================================================
                                                    TIPO DE MEDIÇÃO
                                                ================================================== */}

                                            <div className="produtividade-tipo-select">

                                                <label className="produtividade-tipo-label">
                                                    Tipo de medição
                                                </label>

                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Escolha o tipo de relatório"

                                                    styles={
                                                        selectDarkStyles
                                                    }

                                                    options={
                                                        produtividadeMedicaoOptions
                                                    }

                                                    value={
                                                        produtividadeMedicaoOptions.find(
                                                            (item) =>
                                                                item.value ===
                                                                tipoMedicao
                                                        )
                                                    }

                                                    onChange={(
                                                        selectedOption
                                                    ) => {

                                                        const novaMedicao =
                                                            selectedOption?.value ||
                                                            "km";


                                                        setTipoMedicao(
                                                            novaMedicao
                                                        );


                                                        // ==========================================
                                                        // ALTERA AUTOMATICAMENTE O SEGUNDO SELECT
                                                        // ==========================================

                                                        if (
                                                            novaMedicao === "km"
                                                        ) {

                                                            setTipoProdutividade(
                                                                "resumo"
                                                            );

                                                        } else {

                                                            setTipoProdutividade(
                                                                "ho_resumo"
                                                            );

                                                        }


                                                        // ==========================================
                                                        // LIMPA RESULTADO
                                                        // ==========================================

                                                        setDadosRelatorio(
                                                            []
                                                        );


                                                        setPdfHabilitado(
                                                            false
                                                        );

                                                    }}

                                                    isSearchable={
                                                        false
                                                    }

                                                    isClearable={
                                                        false
                                                    }

                                                    menuPortalTarget={
                                                        document.body
                                                    }

                                                    menuPosition="fixed"
                                                />

                                            </div>


                                            {/* ==================================================
        TIPO DO RELATÓRIO
    ================================================== */}

                                            <div className="produtividade-tipo-select">

                                                <label className="produtividade-tipo-label">
                                                    Tipo de relatório
                                                </label>

                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Agurdando o tipo de relatório..."

                                                    styles={
                                                        selectDarkStyles
                                                    }

                                                    options={
                                                        produtividadeTipoFiltrado
                                                    }

                                                    value={
                                                        produtividadeTipoFiltrado.find(
                                                            (item) =>
                                                                item.value ===
                                                                tipoProdutividade
                                                        )
                                                    }

                                                    onChange={(
                                                        selectedOption
                                                    ) => {

                                                        setTipoProdutividade(
                                                            selectedOption?.value ||
                                                            (
                                                                tipoMedicao === "km"
                                                                    ? "resumo"
                                                                    : "ho_resumo"
                                                            )
                                                        );


                                                        // ==========================================
                                                        // LIMPA RESULTADO
                                                        // ==========================================

                                                        setDadosRelatorio(
                                                            []
                                                        );


                                                        setPdfHabilitado(
                                                            false
                                                        );

                                                    }}

                                                    isSearchable={
                                                        false
                                                    }

                                                    isClearable={
                                                        false
                                                    }

                                                    menuPortalTarget={
                                                        document.body
                                                    }

                                                    menuPosition="fixed"
                                                />

                                            </div>

                                        </div>

                                    </div>


                                    <div
                                        className="col-md-6"
                                    >


                                        <div className="produtividade-tipo-info">

                                            <div className="informativo-header">
                                                <InfoOutlinedIcon className="informativo-icon" />
                                                <span>COMO FUNCIONA</span>
                                            </div>

                                            {(tipoProdutividade === "resumo" ||
                                                tipoProdutividade === "detalhado") && (
                                                    <>
                                                        <div className="informativo-item">
                                                            <h6>KM Resumo</h6>
                                                            <span>
                                                                Uma linha por veículo, com o KM total percorrido
                                                                durante o período selecionado.
                                                            </span>
                                                        </div>

                                                        <div className="informativo-item">
                                                            <h6>KM Detalhado</h6>
                                                            <span>
                                                                Uma linha por veículo para cada dia encontrado
                                                                no período, com o KM percorrido diariamente.
                                                            </span>
                                                        </div>
                                                    </>
                                                )}

                                            {(tipoProdutividade === "ho_resumo" ||
                                                tipoProdutividade === "ho_detalhado") && (
                                                    <>
                                                        <div className="informativo-item">
                                                            <h6>HO Resumo</h6>
                                                            <span>
                                                                Uma linha por veículo, com o total de horas
                                                                trabalhadas no período, calculado pela diferença
                                                                do horímetro.
                                                            </span>
                                                        </div>

                                                        <div className="informativo-item">
                                                            <h6>HO Detalhado</h6>
                                                            <span>
                                                                Uma linha por veículo para cada dia encontrado
                                                                no período, com as horas trabalhadas diariamente,
                                                                calculadas pela diferença do horímetro.
                                                            </span>
                                                        </div>
                                                    </>
                                                )}

                                        </div>



                                    </div>

                                </div>

                            </section>
























                            {/* ==================================================
                  02 — VEÍCULO
                  ================================================== */}
                            <section className="produtividade-section">

                                <div className="produtividade-section-header">

                                    <span
                                        className="produtividade-section-number"
                                    >
                                        02
                                    </span>

                                    <div>

                                        <span
                                            className="produtividade-section-title"
                                        >
                                            Veículo
                                        </span>

                                        <span
                                            className="produtividade-section-description"
                                        >
                                            Selecione o veículo ou grupo para consultar
                                        </span>

                                    </div>

                                </div>


                                <div className="row">

                                    {/* ==================================================
                                    PLACA
                                    ================================================== */}



                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <label className="form-label produtividade-label mb-0">
                                                Placa
                                            </label>

                                            <button
                                                type="button"
                                                className="btn-selecionar-todos"
                                                disabled={gruposSelecionados.length > 0}
                                                onClick={async () => {
                                                    const escapeHtml = (valor) =>
                                                        String(valor ?? "").replace(/[&<>"']/g, (char) => ({
                                                            "&": "&amp;",
                                                            "<": "&lt;",
                                                            ">": "&gt;",
                                                            '"': "&quot;",
                                                            "'": "&#39;"
                                                        })[char]);

                                                    const resultado = await Swal.fire({
                                                        title: "Selecionar veículos",

                                                        html: `
                        <div class="swal-veiculos">
                            <div class="swal-veiculos-resumo">
                                <span>Veículos selecionados</span>
                                <strong id="contador-veiculos">
                                    ${veiculosSelecionados.length} / ${opcoesVeiculos.length}
                                </strong>
                            </div>

                            <input
                                id="busca-veiculos"
                                class="swal2-input swal-veiculos-busca"
                                placeholder="Buscar por placa ou nome..."
                                autocomplete="off"
                            />

                            <div class="swal-veiculos-acoes">
                                <button type="button" id="marcar-todos-veiculos">
                                    Selecionar todos
                                </button>

                                <button type="button" id="limpar-veiculos">
                                    Limpar seleção
                                </button>
                            </div>

                            <div class="swal-veiculos-lista">
                                ${[
                                                                ...opcoesVeiculos.filter((v) =>
                                                                    veiculosSelecionados.some((s) =>
                                                                        String(s?.value ?? s?.id ?? s?.placa ?? "").trim().toLowerCase() ===
                                                                        String(v?.value ?? v?.id ?? v?.placa ?? "").trim().toLowerCase()
                                                                    )
                                                                ),
                                                                ...opcoesVeiculos.filter((v) =>
                                                                    !veiculosSelecionados.some((s) =>
                                                                        String(s?.value ?? s?.id ?? s?.placa ?? "").trim().toLowerCase() ===
                                                                        String(v?.value ?? v?.id ?? v?.placa ?? "").trim().toLowerCase()
                                                                    )
                                                                )
                                                            ].map((v, i) => `
                                    <label
                                        class="swal-veiculo-item"
                                        data-busca="${escapeHtml(
                                                                `${v.placa} ${v.nome}`.toLowerCase()
                                                            )}"
                                    >
                                        <input
                                            type="checkbox"
                                            class="checkbox-veiculo"
                                            value="${i}"
                                            ${veiculosSelecionados.some((s) =>
                                                                String(s?.value ?? s?.id ?? s?.placa ?? "").trim().toLowerCase() ===
                                                                String(v?.value ?? v?.id ?? v?.placa ?? "").trim().toLowerCase()
                                                            ) ? "checked" : ""
                                                                }
                                        />

                                        <span class="swal-veiculo-info">
                                            <strong>${escapeHtml(v.placa)}</strong>
                                            <small>${escapeHtml(v.nome)}</small>
                                        </span>
                                    </label>
                                `).join("")}
                            </div>

                            <p class="swal-veiculos-aviso">
                                Selecione os veículos que deseja incluir no relatório.
                            </p>
                        </div>
                    `,

                                                        background: "#0b1924",
                                                        color: "#e5edf5",
                                                        width: "600px",

                                                        confirmButtonText: "Confirmar seleção",
                                                        cancelButtonText: "Cancelar",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#168FCA",
                                                        cancelButtonColor: "#263746",

                                                        customClass: {
                                                            popup: "swal-veiculos-popup",
                                                            title: "swal-veiculos-titulo",
                                                            htmlContainer: "swal-veiculos-conteudo",
                                                            confirmButton: "swal-veiculos-confirmar",
                                                            cancelButton: "swal-veiculos-cancelar"
                                                        },

                                                        didOpen: () => {
                                                            const popup = Swal.getPopup();
                                                            const busca = popup.querySelector("#busca-veiculos");
                                                            const lista = popup.querySelector(".swal-veiculos-lista");
                                                            const contador = popup.querySelector("#contador-veiculos");
                                                            const marcarTodos = popup.querySelector("#marcar-todos-veiculos");
                                                            const limpar = popup.querySelector("#limpar-veiculos");

                                                            const checkboxes = () =>
                                                                [...popup.querySelectorAll(".checkbox-veiculo")];

                                                            const atualizarContador = () => {
                                                                const checks = checkboxes();
                                                                const selecionados = checks.filter(c => c.checked).length;

                                                                contador.textContent =
                                                                    `${selecionados} / ${checks.length}`;

                                                                marcarTodos.textContent =
                                                                    checks.length > 0 &&
                                                                        selecionados === checks.length
                                                                        ? "Desmarcar todos"
                                                                        : "Selecionar todos";
                                                            };

                                                            const filtrar = () => {
                                                                const termo = busca.value.trim().toLowerCase();

                                                                popup.querySelectorAll(".swal-veiculo-item").forEach(item => {
                                                                    item.style.display =
                                                                        item.dataset.busca.includes(termo)
                                                                            ? "flex"
                                                                            : "none";
                                                                });
                                                            };

                                                            busca.addEventListener("input", filtrar);
                                                            lista.addEventListener("change", atualizarContador);

                                                            marcarTodos.addEventListener("click", () => {
                                                                const visiveis = [
                                                                    ...popup.querySelectorAll(".swal-veiculo-item")
                                                                ].filter(item => item.style.display !== "none");

                                                                const desmarcar = visiveis.length > 0 &&
                                                                    visiveis.every(item =>
                                                                        item.querySelector("input").checked
                                                                    );

                                                                visiveis.forEach(item => {
                                                                    item.querySelector("input").checked = !desmarcar;
                                                                });

                                                                atualizarContador();
                                                            });

                                                            limpar.addEventListener("click", () => {
                                                                checkboxes().forEach(c => {
                                                                    c.checked = false;
                                                                });

                                                                atualizarContador();
                                                            });

                                                            atualizarContador();
                                                            busca.focus();
                                                        },

                                                        preConfirm: () => {
                                                            const popup = Swal.getPopup();

                                                            const selecionados = [
                                                                ...popup.querySelectorAll(".checkbox-veiculo:checked")
                                                            ].map(c => {
                                                                const indice = Number(c.value);
                                                                const selecionadosOrdenados = [
                                                                    ...opcoesVeiculos.filter((v) =>
                                                                        veiculosSelecionados.some((s) =>
                                                                            String(s?.value ?? s?.id ?? s?.placa ?? "").trim().toLowerCase() ===
                                                                            String(v?.value ?? v?.id ?? v?.placa ?? "").trim().toLowerCase()
                                                                        )
                                                                    ),
                                                                    ...opcoesVeiculos.filter((v) =>
                                                                        !veiculosSelecionados.some((s) =>
                                                                            String(s?.value ?? s?.id ?? s?.placa ?? "").trim().toLowerCase() ===
                                                                            String(v?.value ?? v?.id ?? v?.placa ?? "").trim().toLowerCase()
                                                                        )
                                                                    )
                                                                ];

                                                                return selecionadosOrdenados[indice];
                                                            });

                                                            return selecionados;
                                                        }
                                                    });

                                                    if (!resultado.isConfirmed) return;

                                                    const veiculosEscolhidos = resultado.value;

                                                    setPlaca(null);
                                                    setGrupo(null);
                                                    setGruposSelecionados([]);

                                                    setInputValue("");
                                                    setInputValueGrupo("");

                                                    setDadosRelatorio([]);
                                                    setPdfHabilitado(false);

                                                    setVeiculosSelecionados(veiculosEscolhidos);

                                                    setTodosVeiculosSelecionados(
                                                        veiculosEscolhidos.length === opcoesVeiculos.length
                                                    );
                                                }}
                                            >
                                                Selecionar veículos
                                            </button>
                                        </div>

                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            styles={selectDarkStyles}
                                            value={
                                                todosVeiculosSelecionados
                                                    ? {
                                                        value: "TODOS",
                                                        label: "Todos os veículos",
                                                        nome: "Todos os veículos",
                                                    }
                                                    : placa
                                            }
                                            inputValue={inputValue}
                                            options={[
                                                {
                                                    value: "TODOS",
                                                    label: "Todos os veículos",
                                                    nome: "Todos os veículos",
                                                    isTodos: true,
                                                },
                                                ...opcoesVeiculos,
                                            ]}
                                            filterOption={filterOption}

                                            isDisabled={
                                                veiculosSelecionados.length >= 1 ||
                                                gruposSelecionados.length >= 1
                                            }

                                            formatOptionLabel={(option) => (
                                                <div className="produtividade-select-veiculo">
                                                    <div className="produtividade-select-veiculo-placa">
                                                        {option.isTodos
                                                            ? "TODOS"
                                                            : option.placa}
                                                    </div>

                                                    <div className="produtividade-select-veiculo-nome">
                                                        {option.nome}
                                                    </div>
                                                </div>
                                            )}

                                            onInputChange={(value, { action }) => {
                                                if (action === "input-change") {
                                                    setInputValue(value);
                                                }
                                            }}

                                            onChange={(selectedOption) => {
                                                if (selectedOption?.isTodos) {
                                                    setTodosVeiculosSelecionados(true);

                                                    setPlaca(null);
                                                    setVeiculosSelecionados([]);
                                                    setGruposSelecionados([]);
                                                    setGrupo(null);

                                                    setInputValue("");
                                                    setInputValueGrupo("");
                                                } else {
                                                    setTodosVeiculosSelecionados(false);
                                                    setPlaca(selectedOption);

                                                    setVeiculosSelecionados([]);
                                                    setGruposSelecionados([]);
                                                    setGrupo(null);

                                                    setInputValue("");
                                                    setInputValueGrupo("");
                                                }

                                                setDadosRelatorio([]);
                                                setPdfHabilitado(false);
                                            }}

                                            placeholder={
                                                gruposSelecionados.length >= 1
                                                    ? "Limpe a seleção de grupos para selecionar veículos"
                                                    : veiculosSelecionados.length >= 1
                                                        ? `${veiculosSelecionados.length} veículo(s) selecionado(s) no modal`
                                                        : todosVeiculosSelecionados
                                                            ? "Todos os veículos selecionados"
                                                            : "Selecione veiculo desejado "
                                            }

                                            isClearable
                                            noOptionsMessage={() => "Nenhum veículo encontrado"}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                    </div>



                                    {/* ==================================================
            GRUPO
            ================================================== */}



                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <label className="form-label produtividade-label mb-0">
                                                Grupo
                                            </label>

                                            <button
                                                type="button"
                                                className="btn-selecionar-todos"
                                                disabled={veiculosSelecionados.length > 0}
                                                onClick={async () => {
                                                    const escapeHtml = (valor) =>
                                                        String(valor ?? "").replace(/[&<>"']/g, (char) => ({
                                                            "&": "&amp;",
                                                            "<": "&lt;",
                                                            ">": "&gt;",
                                                            '"': "&quot;",
                                                            "'": "&#39;"
                                                        })[char]);

                                                    const chaveGrupo = (g) =>
                                                        String(
                                                            g?.value ??
                                                            g?.id ??
                                                            g?.nome ??
                                                            g?.label ??
                                                            ""
                                                        ).trim().toLowerCase();

                                                    // Grupos selecionados primeiro; os demais vêm depois.
                                                    const gruposOrdenados = [
                                                        ...opcoesGrupos.filter((g) =>
                                                            gruposSelecionados.some(
                                                                (selecionado) =>
                                                                    chaveGrupo(selecionado) === chaveGrupo(g)
                                                            )
                                                        ),
                                                        ...opcoesGrupos.filter((g) =>
                                                            !gruposSelecionados.some(
                                                                (selecionado) =>
                                                                    chaveGrupo(selecionado) === chaveGrupo(g)
                                                            )
                                                        )
                                                    ];

                                                    const resultado = await Swal.fire({
                                                        title: "Selecionar grupos",

                                                        html: `
                        <div class="swal-veiculos">
                            <div class="swal-veiculos-resumo">
                                <span>Grupos selecionados</span>
                                <strong id="contador-grupos">
                                    ${gruposSelecionados.length} / ${opcoesGrupos.length}
                                </strong>
                            </div>

                            <input
                                id="busca-grupos"
                                class="swal2-input swal-veiculos-busca"
                                placeholder="Buscar grupo..."
                                autocomplete="off"
                            />

                            <div class="swal-veiculos-acoes">
                                <button type="button" id="marcar-todos-grupos">
                                    Selecionar todos
                                </button>

                                <button type="button" id="limpar-grupos">
                                    Limpar seleção
                                </button>
                            </div>

                            <div class="swal-veiculos-lista">
                                ${gruposOrdenados.map((g, i) => `
                                    <label
                                        class="swal-veiculo-item"
                                        data-busca="${escapeHtml(
                                                            `${g.nome ?? g.label ?? ""} ${g.id ?? g.value ?? ""}`.toLowerCase()
                                                        )}"
                                    >
                                        <input
                                            type="checkbox"
                                            class="checkbox-grupo"
                                            value="${i}"
                                            ${gruposSelecionados.some(
                                                            (selecionado) =>
                                                                chaveGrupo(selecionado) === chaveGrupo(g)
                                                        ) ? "checked" : ""
                                                            }
                                        />

                                        <span class="swal-veiculo-info">
                                            <strong>${escapeHtml(g.nome ?? g.label ?? "Grupo")}</strong>
                                        </span>
                                    </label>
                                `).join("")}
                            </div>

                            <p class="swal-veiculos-aviso">
                                Selecione os grupos que deseja incluir no relatório.
                            </p>
                        </div>
                    `,

                                                        background: "#0b1924",
                                                        color: "#e5edf5",
                                                        width: "600px",

                                                        confirmButtonText: "Confirmar seleção",
                                                        cancelButtonText: "Cancelar",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#168FCA",
                                                        cancelButtonColor: "#263746",

                                                        customClass: {
                                                            popup: "swal-veiculos-popup",
                                                            title: "swal-veiculos-titulo",
                                                            htmlContainer: "swal-veiculos-conteudo",
                                                            confirmButton: "swal-veiculos-confirmar",
                                                            cancelButton: "swal-veiculos-cancelar"
                                                        },

                                                        didOpen: () => {
                                                            const popup = Swal.getPopup();
                                                            const busca = popup.querySelector("#busca-grupos");
                                                            const lista = popup.querySelector(".swal-veiculos-lista");
                                                            const contador = popup.querySelector("#contador-grupos");
                                                            const marcarTodos = popup.querySelector("#marcar-todos-grupos");
                                                            const limpar = popup.querySelector("#limpar-grupos");

                                                            const checkboxes = () =>
                                                                [...popup.querySelectorAll(".checkbox-grupo")];

                                                            const atualizarContador = () => {
                                                                const checks = checkboxes();
                                                                const selecionados = checks.filter(
                                                                    (c) => c.checked
                                                                ).length;

                                                                contador.textContent =
                                                                    `${selecionados} / ${checks.length}`;

                                                                marcarTodos.textContent =
                                                                    checks.length > 0 &&
                                                                        selecionados === checks.length
                                                                        ? "Desmarcar todos"
                                                                        : "Selecionar todos";
                                                            };

                                                            busca.addEventListener("input", () => {
                                                                const termo = busca.value.trim().toLowerCase();

                                                                popup.querySelectorAll(".swal-veiculo-item")
                                                                    .forEach((item) => {
                                                                        item.style.display =
                                                                            item.dataset.busca.includes(termo)
                                                                                ? "flex"
                                                                                : "none";
                                                                    });
                                                            });

                                                            lista.addEventListener("change", atualizarContador);

                                                            marcarTodos.addEventListener("click", () => {
                                                                const visiveis = [
                                                                    ...popup.querySelectorAll(".swal-veiculo-item")
                                                                ].filter(
                                                                    (item) => item.style.display !== "none"
                                                                );

                                                                const desmarcar = visiveis.every(
                                                                    (item) => item.querySelector("input").checked
                                                                );

                                                                visiveis.forEach((item) => {
                                                                    item.querySelector("input").checked = !desmarcar;
                                                                });

                                                                atualizarContador();
                                                            });

                                                            limpar.addEventListener("click", () => {
                                                                checkboxes().forEach((c) => {
                                                                    c.checked = false;
                                                                });

                                                                atualizarContador();
                                                            });

                                                            atualizarContador();
                                                            busca.focus();
                                                        },

                                                        preConfirm: () => {
                                                            const popup = Swal.getPopup();

                                                            return [
                                                                ...popup.querySelectorAll(".checkbox-grupo:checked")
                                                            ].map(
                                                                (c) => gruposOrdenados[Number(c.value)]
                                                            );
                                                        }
                                                    });

                                                    if (!resultado.isConfirmed) return;

                                                    setGruposSelecionados(resultado.value);

                                                    // Limpa a seleção individual e múltipla de veículos.
                                                    setPlaca(null);
                                                    setVeiculosSelecionados([]);
                                                    setTodosVeiculosSelecionados(false);

                                                    setGrupo(null);
                                                    setInputValue("");
                                                    setInputValueGrupo("");

                                                    setDadosRelatorio([]);
                                                    setPdfHabilitado(false);
                                                }}
                                            >
                                                Selecionar grupos
                                            </button>
                                        </div>

                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            styles={selectDarkStyles}
                                            value={grupo}
                                            inputValue={inputValueGrupo}
                                            options={opcoesGrupos}
                                            isDisabled={
                                                veiculosSelecionados.length > 0 ||
                                                gruposSelecionados.length > 0
                                            }
                                            placeholder={
                                                gruposSelecionados.length > 0
                                                    ? `${gruposSelecionados.length} grupo(s) selecionado(s) no modal`
                                                    : veiculosSelecionados.length > 0
                                                        ? "Limpe a seleção de veículos para escolher um grupo"
                                                        : "Buscar por grupo"
                                            }
                                            onInputChange={(value, { action }) => {
                                                if (action === "input-change") {
                                                    setInputValueGrupo(value);
                                                }
                                            }}
                                            onChange={(selectedOption) => {
                                                setGrupo(selectedOption);

                                                setGruposSelecionados([]);
                                                setVeiculosSelecionados([]);
                                                setTodosVeiculosSelecionados(false);

                                                setPlaca(null);
                                                setInputValueGrupo("");
                                                setInputValue("");

                                                setDadosRelatorio([]);
                                                setPdfHabilitado(false);
                                            }}
                                            formatOptionLabel={(option) => (
                                                <div className="produtividade-select-grupo">
                                                    <div className="produtividade-select-grupo-nome">
                                                        {option?.nome || option?.label || "Grupo"}
                                                    </div>
                                                </div>
                                            )}
                                            isClearable
                                            noOptionsMessage={() => "Nenhum grupo encontrado"}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                    </div>



                                </div>

                            </section>


                            {/* ==================================================
                  03 — PERÍODO
                  ================================================== */}

                            <section
                                className="produtividade-section"
                            >

                                <div
                                    className="produtividade-section-header"
                                >

                                    <span
                                        className="produtividade-section-number"
                                    >
                                        03
                                    </span>


                                    <div>

                                        <span
                                            className="produtividade-section-title"
                                        >
                                            Período
                                        </span>

                                        <span
                                            className="produtividade-section-description"
                                        >
                                            Defina o intervalo da consulta
                                        </span>

                                    </div>

                                </div>


                                <div
                                    className="row"
                                >


                                    {/* DATA INICIAL */}

                                    <div
                                        className="col-md-3"
                                    >

                                        <label
                                            className="form-label produtividade-label"
                                        >
                                            Data inicial
                                        </label>


                                        <DatePicker
                                            selected={
                                                de
                                                    ? new Date(
                                                        `${de}T00:00:00`
                                                    )
                                                    : null
                                            }

                                            onChange={(
                                                novaData
                                            ) => {

                                                if (
                                                    !novaData
                                                ) {

                                                    return;

                                                }


                                                const ano =
                                                    novaData
                                                        .getFullYear();


                                                const mes =
                                                    String(
                                                        novaData
                                                            .getMonth() +
                                                        1
                                                    )
                                                        .padStart(
                                                            2,
                                                            "0"
                                                        );


                                                const dia =
                                                    String(
                                                        novaData
                                                            .getDate()
                                                    )
                                                        .padStart(
                                                            2,
                                                            "0"
                                                        );


                                                const novaDataTexto =
                                                    `${ano}-${mes}-${dia}`;


                                                setDe(
                                                    novaDataTexto
                                                );


                                                if (
                                                    new Date(
                                                        `${ate}T00:00:00`
                                                    ) <
                                                    new Date(
                                                        `${novaDataTexto}T00:00:00`
                                                    )
                                                ) {

                                                    setAte(
                                                        novaDataTexto
                                                    );

                                                }

                                            }}

                                            dateFormat="dd/MM/yyyy"

                                            className="form-control produtividade-input"

                                            placeholderText="DD/MM/AAAA"

                                            locale={
                                                ptBRDateFns
                                            }

                                            showPopperArrow={
                                                false
                                            }

                                            showMonthDropdown

                                            dropdownMode="select"

                                            popperPlacement="bottom-start"

                                        />

                                    </div>


                                    {/* HORA INICIAL */}

                                    <div
                                        className="col-md-3"
                                    >

                                        <label
                                            className="form-label produtividade-label"
                                        >
                                            Hora inicial
                                        </label>


                                        <input
                                            type="text"

                                            inputMode="numeric"

                                            maxLength={5}

                                            value={
                                                horaDe
                                            }

                                            placeholder="00:00"

                                            className={
                                                `form-control produtividade-input ${erroHoraDe
                                                    ? "produtividade-input-erro"
                                                    : ""
                                                }`
                                            }

                                            onChange={
                                                handleHoraDeChange
                                            }

                                            onBlur={() => {

                                                if (
                                                    !horaDe
                                                ) {

                                                    setHoraDe(
                                                        "00:00"
                                                    );

                                                    return;

                                                }


                                                if (
                                                    horaDe.length <
                                                    5
                                                ) {

                                                    setErroHoraDe(
                                                        "Informe o horário completo."
                                                    );

                                                }

                                            }}

                                        />


                                        {erroHoraDe && (

                                            <small
                                                className="produtividade-erro"
                                            >
                                                {erroHoraDe}
                                            </small>

                                        )}

                                    </div>


                                    {/* DATA FINAL */}

                                    <div
                                        className="col-md-3"
                                    >

                                        <label
                                            className="form-label produtividade-label"
                                        >
                                            Data final
                                        </label>


                                        <DatePicker
                                            selected={
                                                ate
                                                    ? new Date(
                                                        `${ate}T00:00:00`
                                                    )
                                                    : null
                                            }

                                            onChange={(
                                                novaData
                                            ) => {

                                                if (
                                                    !novaData
                                                ) {

                                                    return;

                                                }


                                                const ano =
                                                    novaData
                                                        .getFullYear();


                                                const mes =
                                                    String(
                                                        novaData
                                                            .getMonth() +
                                                        1
                                                    )
                                                        .padStart(
                                                            2,
                                                            "0"
                                                        );


                                                const dia =
                                                    String(
                                                        novaData
                                                            .getDate()
                                                    )
                                                        .padStart(
                                                            2,
                                                            "0"
                                                        );


                                                const novaDataTexto =
                                                    `${ano}-${mes}-${dia}`;


                                                if (
                                                    new Date(
                                                        `${novaDataTexto}T00:00:00`
                                                    ) <
                                                    new Date(
                                                        `${de}T00:00:00`
                                                    )
                                                ) {

                                                    setAte(
                                                        de
                                                    );

                                                    return;

                                                }


                                                setAte(
                                                    novaDataTexto
                                                );

                                            }}

                                            dateFormat="dd/MM/yyyy"

                                            className="form-control produtividade-input"

                                            placeholderText="DD/MM/AAAA"

                                            locale={
                                                ptBRDateFns
                                            }

                                            showPopperArrow={
                                                false
                                            }

                                            showMonthDropdown

                                            dropdownMode="select"

                                            popperPlacement="bottom-start"

                                        />

                                    </div>


                                    {/* HORA FINAL */}

                                    <div
                                        className="col-md-3"
                                    >

                                        <label
                                            className="form-label produtividade-label"
                                        >
                                            Hora final
                                        </label>


                                        <input
                                            type="text"

                                            inputMode="numeric"

                                            maxLength={5}

                                            value={
                                                horaAte
                                            }

                                            placeholder="23:59"

                                            className={
                                                `form-control produtividade-input ${erroHoraAte
                                                    ? "produtividade-input-erro"
                                                    : ""
                                                }`
                                            }

                                            onChange={
                                                handleHoraAteChange
                                            }

                                            onBlur={() => {

                                                if (
                                                    !horaAte
                                                ) {

                                                    setHoraAte(
                                                        "23:59"
                                                    );

                                                    return;

                                                }


                                                if (
                                                    horaAte.length <
                                                    5
                                                ) {

                                                    setErroHoraAte(
                                                        "Informe o horário completo."
                                                    );

                                                }

                                            }}

                                        />


                                        {erroHoraAte && (

                                            <small
                                                className="produtividade-erro"
                                            >
                                                {erroHoraAte}
                                            </small>

                                        )}

                                    </div>

                                </div>

                            </section>


                            {/* ==================================================
                  AÇÕES
                  ================================================== */}

                            <div
                                className="produtividade-actions"
                            >

                                <div
                                    className="produtividade-actions-info"
                                >

                                    <span>
                                        Ações do relatório
                                    </span>

                                    <small>
                                        Consulte ou exporte os dados
                                    </small>

                                </div>


                                <div className="produtividade-buttons">

                                    {/* ========================================== */}
                                    {/* EXCEL */}
                                    {/* ========================================== */}

                                    <button
                                        type="button"
                                        className="
                                                produtividade-btn
                                                produtividade-btn-excel
                                            "
                                        onClick={async () => {
                                            if (operacaoEmAndamento) return;

                                            setLoadingExcel(true);

                                            try {
                                                await exportarExcel();
                                            } catch (error) {
                                                console.error("Erro ao exportar Excel:", error);
                                            } finally {
                                                setLoadingExcel(false);
                                            }
                                        }}
                                        disabled={operacaoEmAndamento}
                                    >
                                        {loadingExcel ? (
                                            <>
                                                <span className="produtividade-spinner-consultar"></span>
                                                <span>Gerando Excel...</span>
                                            </>
                                        ) : (
                                            <>
                                                <RiFileExcel2Line size={19} />
                                                <span>Excel</span>
                                            </>
                                        )}
                                    </button>


                                    {/* ========================================== */}
                                    {/* PDF */}
                                    {/* ========================================== */}

                                    <button
                                        type="button"
                                        className="
                                                produtividade-btn
                                                produtividade-btn-pdf
                                                                        "
                                        onClick={async () => {
                                            if (operacaoEmAndamento) return;

                                            setLoadingPDF(true);

                                            try {
                                                await gerarPDF();
                                            } catch (error) {
                                                console.error("Erro ao gerar PDF:", error);
                                            } finally {
                                                setLoadingPDF(false);
                                            }
                                        }}
                                        disabled={operacaoEmAndamento}
                                    >
                                        {loadingPDF ? (
                                            <>
                                                <span className="produtividade-spinner-consultar"></span>
                                                <span>Gerando PDF...</span>
                                            </>
                                        ) : (
                                            <>
                                                <FaRegFilePdf size={19} />
                                                <span>PDF</span>
                                            </>
                                        )}
                                    </button>


                                    {/* ========================================== */}
                                    {/* CONSULTAR */}
                                    {/* ========================================== */}

                                    <button
                                        type="submit"
                                        className="
            produtividade-btn
            produtividade-btn-consultar
        "
                                        disabled={operacaoEmAndamento}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="produtividade-spinner-consultar"></span>
                                                <span>Consultando...</span>
                                            </>
                                        ) : (
                                            <>
                                                <TbGps size={20} />
                                                <span>Consultar</span>
                                            </>
                                        )}
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>

                </nav>







            </div>




            {/* ======================================================
            RESUMO
            ====================================================== */}


            <div className="produtividade-resumo">

                {/* TIPO DO RELATÓRIO */}
                <div className="produtividade-resumo-card">
                    <span className="resumo-label">
                        Tipo
                    </span>

                    <strong className="resumo-value">
                        {getProdutividadeTipoLabel(tipoProdutividade)}
                    </strong>
                </div>

                {/* QUANTIDADE DE REGISTROS */}
                <div className="produtividade-resumo-card">
                    <span className="resumo-label">
                        Registros
                    </span>

                    <strong className="resumo-value">
                        {dadosRelatorio.length}
                    </strong>
                </div>

                {/* KM: EXIBE SOMENTE NOS RELATÓRIOS KM */}
                {(
                    tipoProdutividade === "resumo" ||
                    tipoProdutividade === "detalhado"
                ) && (
                        <div className="produtividade-resumo-card">
                            <span className="resumo-label">
                                KM Total
                            </span>

                            <strong className="resumo-value resumo-km">
                                {formatarKm(kmTotal)}
                                <small> km</small>
                            </strong>
                        </div>
                    )}

                {/* HORÍMETRO: EXIBE SOMENTE NOS RELATÓRIOS HO */}
                {(
                    tipoProdutividade === "ho_resumo" ||
                    tipoProdutividade === "ho_detalhado"
                ) && (
                        <div className="produtividade-resumo-card">
                            <span className="resumo-label">
                                Total de horas trabalhadas
                            </span>

                            <strong className="resumo-value resumo-horas">
                                {formatarHoras(horasTotal)}
                            </strong>
                        </div>
                    )}

            </div>



            {/* ======================================================
                    TABELA
                    ====================================================== */}

            <div className="produtividade-tabela-container" ref={tabelaRef}>

                <DataGrid className="produtividade-tabela"

                    disableColumnMenu

                    disableColumnFilter

                    disableColumnSorting={
                        false
                    }

                    rows={[
                        ...dadosRelatorio
                    ]
                        .sort((a, b) =>
                            (a.placa ?? "").localeCompare(b.placa ?? "")
                        )
                        .map((row, index) => ({
                            ...row,
                            id: row.id ?? `${tipoProdutividade}-${index}`,
                        }))
                    }



                    columns={
                        columns

                    }

                    getRowClassName={(params) => {
                        const index = dadosRelatorio.findIndex(
                            (row) => row.id === params.row.id
                        );

                        const atual = params.row;
                        const anterior = dadosRelatorio[index - 1];

                        return !anterior || anterior.placa !== atual.placa
                            ? "produtividade-grupo-inicio"
                            : "produtividade-grupo-linha";
                    }}

                    localeText={{

                        ...ptBR
                            .components
                            .MuiDataGrid
                            .defaultProps
                            .localeText,

                        noRowsLabel:
                            "Não existem registros para o período.",

                    }}

                    pagination

                    pageSizeOptions={[
                        100,
                        50,
                        20,
                        {
                            value: -1,
                            label: "Todos",
                        },
                    ]}

                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 100,
                                page: 0,
                            },
                        },
                    }}

                    slots={{

                        footer: () => (

                            <ProdutividadeFooter
                                kmTotal={kmTotal}
                                ehHO={
                                    tipoProdutividade === "ho_resumo" ||
                                    tipoProdutividade === "ho_detalhado"
                                }
                                horasTotal={horasTotal}
                                formatarHoras={formatarHoras}
                            />


                        ),

                    }}

                    slotProps={{
                        pagination: {
                            labelRowsPerPage: "Linhas por página",

                            SelectProps: {
                                MenuProps: {
                                    disableScrollLock: true,
                                },
                            },
                        },
                    }}

                    autoHeight={
                        false
                    }

                    disableRowSelectionOnClick

                />

            </div>



        </ThemeProvider>

    );

}


export default RelatorioProdutividade;